import { Basic } from "../basic.js";
import { ActionFactory } from "./../../actions/ActionFactory.js";
import { journalWorker } from "../../observer/journalWorker.js";
import { Converter } from "../../observer/converter.js";
import { ObjectTree } from "../trend/objecttree.js";
import { Inputs } from "../../lib/inputs.js";
import { DataTypes } from "generated";
import { MSToolbar } from "../trend/toolbar.js";
import { MSDateTimePicker } from "../dtpicker/dtpicker.js";
import { MSInterval } from "../interval/interval.js";
import {
    exportTextfile,
    getUniqueNumber,
    getFormattedValue,
    generateFileName,
} from "../../lib/utils.js";
import styles from './style.css'

/**
 * @class MSJournal
 * @extends Basic
 * @classdesc Журнал
 * */
export class MSJournal extends Basic {
    enums(type) {
        if (!this._enums) {
            this._enums = {};
        }
        if (!this._enums[type]) {
            if (
                DataTypes.dataTypes[type] &&
                DataTypes.dataTypes[type].DataType !== `ElementaryType`
            ) {
                const en = DataTypes.dataTypes[type].DisplayValues;
                if (en) {
                    this._enums[type] = {};
                    for (let i = 0; i < en.length; i++) {
                        const el = en[i];
                        this._enums[type][i] = el;
                        this._enums[type][el] = i;
                    }
                }
            }
        }
        return this._enums[type];
    }

    static get observedAttributes() {
        return super.observedAttributes.concat([
            "tablecolumns",
            "legendcolumns",
            "rowstyle",
            "headerrowstyle",
            "filters",
            "filterscombinetype",
            "objectuid",
            "archiveref",
            "interval",
            "till",
            "updateperiod",
            "filtersbackgroundcolor",
            "toolbarbackgroundcolor",
            "fieldstyles",
            "legendbackgroundcolor",
            "limit",
            "showlegend",
            "showtoolbar",
            "autoscroll",
            "usearchive",
            "showfilter",
            "isglobal",
            "hasobjecttree",
            "expandedlevel",
            "askackcomment",
            "customFilters",
            "sortOrder",
            "usetimefilter",
            "statusbartextcolor",
            "showstatusbar",
            "showverticalscrollbar",
            "requesttimeout",
            "filter",
            "ischecked",
            "isfavorite",
            "exportnameformat",
            "windowopeningcontainer",
            "containerforopeningobjectwindows",
            "isvisiblekvit",
        ]);
    }

    constructor() {
        super();
        if (typeof window.customElements.get("ms-dtpicker") === "undefined") {
            window.customElements.define("ms-dtpicker", MSDateTimePicker);
        }
        if (typeof window.customElements.get("ms-interval") === "undefined") {
            window.customElements.define("ms-interval", MSInterval);
        }
        if (!window.customElements.get("ms-toolbar", MSToolbar)) {
            window.customElements.define("ms-toolbar", MSToolbar);
        }
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = `
            <style>
                ${styles}
                .flash-animation {
                    animation: flash linear ${_globalParams.FlashInterval}ms infinite;
                }
            </style>
            <div style="display:flex;flex-direction:column;width:100%;height:100%;">
                <ms-toolbar id='toolbar' style="display: flex; width: 100%; height: 30px; position: relative;"
                buttons='[{"method": "AcknowledgePage", "class": "hmi-j--allpage", "tooltip": "${i18next.t('jornal_toolbar_acknowledgePage')}", "type": "button"},
                {"method": "AcknowledgeAll", "class": "hmi-j--ackall", "tooltip": "${i18next.t('jornal_toolbar_acknowledgeAll')}", "type": "button"},
                {"method": "Download", "class": "hmi-j-export", "tooltip": "${i18next.t('jornal_toolbar_export')}", "type": "button"},
                {"method": "Print", "class": "hmi-j-print", "tooltip": "${i18next.t('jornal_toolbar_print')}", "type": "button"},
                {"type": "expander"},
                {"method": "setSeverity", "class": ["hmi-j-info","hmi-j-info"], "tooltip": ["${i18next.t('jornal_toolbar_priority')}","${i18next.t('jornal_toolbar_priority')}"], "type": "toggle"},
                {"method": "OpenObjectTree", "class": "hmi-j-tree", "tooltip": "${i18next.t('jornal_toolbar_objectTree')}", "type": "button"},
                {"method": "_showTimeFiltr", "class": ["hmi-j-inerval_go","hmi-j-inerval_stop"], "tooltip": ["${i18next.t('jornal_toolbar_timeFilter')}","${i18next.t('jornal_toolbar_timeFilter')}"], "type": "toggle"},
                {"method": "GoToDate", "class": "hmi-j-select-data", "tooltip": "${i18next.t('jornal_toolbar_goDate')}", "type": "button"},
                {"method": "_onLegendClick", "class": ["hmi-j-legend","hmi-j-legend"], "tooltip": ["${i18next.t('jornal_toolbar_showLegend')}","${i18next.t('jornal_toolbar_showLegend')}"], "type": "toggle"},
                {"method": "_onAutoPlayClick", "class": ["hmi-j-play", "hmi-j-pause"], "tooltip": ["${i18next.t('jornal_toolbar_autoscroll')}", "${i18next.t('jornal_toolbar_autoscroll')}"], "type": "toggle"},
                {"method": "_onFilterClick", "class": ["hmi-j-filter","hmi-j-filter"], "tooltip": ["${i18next.t('jornal_toolbar_showFilter')}","${i18next.t('jornal_toolbar_showFilter')}"], "type": "toggle"},
                {"method": "ClearOptions", "class": "hmi-j-reset_settings", "tooltip": "${i18next.t('jornal_toolbar_reset')}", "type": "button"},
                {"method": "_goFirstPage", "class": "hmi-j-step-up", "tooltip": "${i18next.t('jornal_toolbar_goFirstPage')}", "type": "button"},
                {"method": "_goLastPage", "class": "hmi-j-step-down", "tooltip": "${i18next.t('jornal_toolbar_goLastPage')}", "type": "button"}]'></ms-toolbar>
                <div style="flex-grow: 99; overflow: hidden; position: relative;">
                    <table class="jr" style="width:100%;border-collapse:separate;border-spacing:0px;table-layout:fixed;">
                        <thead><tr></tr></thead><tbody></tbody>
                    </table>
                </div>
                <div style="display:none;flex-grow:1;border-top: 1px solid rgba(35, 39, 76, 0.5);box-shadow: rgba(35, 39, 76, 0.5) 0px -2px 5px;" id="footer"></div>
                <div style="display:none;flex-grow:1;border-top: 1px solid rgba(35, 39, 76, 0.5);box-shadow: rgba(35, 39, 76, 0.5) 0px -2px 5px; padding: 2px 10px; background-color:rgb(240, 240, 240)" id="status"></div>
            </div>`;
        /* убрал из стиля footer overflow-y: auto;*/
        this._start = false;
        this.mouseUp = this.mouseUp.bind(this);
        this.mouseMove = this.mouseMove.bind(this);

        this.mouseUpLegend = this.mouseUpLegend.bind(this);
        this.mouseMoveLegend = this.mouseMoveLegend.bind(this);

        this.needReCreate = true;

        this._loadDown = false;
        this._loadUp = false;

        this._autoscroll = true;
        this._askackcomment = true;
        this._first = true;
        this._select = { uid: "", td: null };
        this._recs = [];
        this._sources = [];
        this._sortRecs = [];
        this._curTableRecs = [];
        this._customFilt = {};
        this._filters = [];
        this._clientHandle = 1;
        this._skip = 0;
        this._showLegend = false;
        this._showStatusBar = true;
        this._showVerticalScrollBar = true;

        this.style.display = "flex";
        this.style.overflow = "hidden";
        this.style.boxSizing = "border-box";

        this._main = shadowRoot.querySelector("div");
        this._table = shadowRoot.querySelector("table");
        this._header = this._table.querySelector("thead tr");
        this._toolBar = shadowRoot.getElementById("toolbar");
        this._toolBar.height = 40;
        this._toolBar.context = this;

        this._scrollLeft = 0;
        this._scrollTop = 0;

        this._table.parentNode.onscroll = e => {
            e.preventDefault();
            if (this._table.parentElement.scrollLeft != this._scrollLeft) {
                this._scrollLeft = this._table.parentElement.scrollLeft;
            }

            if (this._table.parentElement.scrollTop != this._scrollTop) {
                const delta =
                    this._table.parentElement.scrollTop - this._scrollTop;
                this._scrollTop = this._table.parentElement.scrollTop;
                const translate = "translate(0," + this._scrollTop + "px)";
                this._header.parentNode.style.transform = translate;

                for (let index = 0; index < this._hs.length; index++) {
                    const element = this._hs[index];
                    element.sep.style.top = this._scrollTop + "px";
                    const h =
                        this._table.clientHeight - this._scrollTop <
                            this._table.parentNode.clientHeight
                            ? this._table.clientHeight - this._scrollTop
                            : this._table.parentNode.clientHeight;
                    element.sep.style.height = h + "px";
                }

                if (
                    this._autoSetAutoscroll &&
                    this._table.parentElement.scrollTop == 0 &&
                    !this._autoscroll
                ) {
                    this._autoSetAutoscroll = false;
                    this.SetParameter("autoscroll", !this._autoscroll, true);
                    this.updateStatusBar();
                } else if (this._autoscroll && !this._autoscrollInit) {
                    this._autoSetAutoscroll = true;
                    this.SetParameter("autoscroll", !this._autoscroll, true);
                    this.updateStatusBar();
                } else if (!this._autoscrollInit && !this._autoscroll) {
                    //&& this._recs.length >= this._limit
                    if (delta > 0) {
                        const a =
                            this._table.offsetHeight -
                            this._table.parentElement.offsetHeight -
                            20;
                        if (
                            a <= this._table.parentElement.scrollTop &&
                            !this._loadDown
                        ) {
                            this._loadDown = true;
                            this._onOneForwardClick();
                        }
                    } else {
                        if (
                            this._table.parentElement.scrollTop < 20 &&
                            !this._loadUp && this.refreshArchivedRecs
                        ) {
                            this._loadUp = true;
                            this._onOneBackClick();
                        }
                    }
                }
            }
        };

        this._footer = shadowRoot.getElementById("footer");
        this._statusBar = shadowRoot.getElementById("status");

        this._body = shadowRoot.querySelector("tbody");
        this._body.onclick = this._onBodyClick.bind(this);
        this._body.ondblclick = this._onDblClick.bind(this);

        this._toolBar.setVisible(
            this._toolBar.elements["_onLegendClick"],
            false
        );
        this._toolBar.setVisible(
            this._toolBar.elements["_onFilterClick"],
            false
        );

        this._baseFilds = [
            { name: "EventType", type: "STRING" },
            { name: "Acked", type: "BOOL" },
            { name: "Active", type: "BOOL" },
            { name: "EventId", type: "STRING" },
            { name: "Time", type: "DATE_AND_TIME" },
            { name: "UpdateType", type: "INT" },
            { name: "TimeTicks", type: "STRING" },
            { name: "AlarmId", type: "INT" },
            { name: "AckedTime", type: "DATE_AND_TIME" },
        ];
        this._baseFildsDict = {
            EventType: 0,
            Ack: 1,
            Acked: 1,
            Active: 2,
            EventId: 3,
            Time: 4,
            UpdateType: 5,
            TimeTicks: 6,
            AlarmId: 7,
            AckedTime: 8,
        };

        this.sw = new journalWorker("journal_" + getUniqueNumber());
        this.sw.upData = this._upData.bind(this);
        this.sw.createMonitoredEvents = this._createMonitoredEvents.bind(this);

        this._headerstyle = document.createElement("style");
        this._headerstyle.type = "text/css";
        shadowRoot.appendChild(this._headerstyle);

        this._rowsstyle = document.createElement("style");
        this._rowsstyle.type = "text/css";
        shadowRoot.appendChild(this._rowsstyle);
        this._loadMarks();
        this.afterSwitch = this.afterSwitch.bind(this);
        window.addEventListener("ms_message", this.afterSwitch);
        this.setPm();
    }
    setPm() {
        const toolBar = this._toolBar
        const toolBarElements = toolBar.elements;
        const isJournalGroupAckEnabled = !$pm.isPermDisabled(this, "JournalGroupAck");
        toolBar.setEnable(toolBarElements["AcknowledgeAll"], isJournalGroupAckEnabled);
        toolBar.setEnable(toolBarElements["AcknowledgePage"], isJournalGroupAckEnabled);
        toolBar.setEnable(toolBarElements["Print"], !$pm.isPermDisabled(this, "JournalPrint"));
        toolBar.setEnable(toolBarElements["Download"], !$pm.isPermDisabled(this, "JournalSave"));
        toolBar.setEnable(toolBarElements["_onFilterClick"], !$pm.isPermDisabled(this, "JournalUseFilters"));
        toolBar.setEnable(toolBarElements["setSeverity"], !$pm.isPermDisabled(this, "JournalUseFilters"));
    }
    setPmHeader() {
        if (!this._header) return;
        const isJournalUseFiltersDisabled = $pm.isPermDisabled(this, "JournalUseFilters");
        this._header.querySelectorAll("span.hmi-j-filter")
            .forEach(x => x.classList.toggle("disable", isJournalUseFiltersDisabled))
    }
    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "afterswitch":
                this._curTableRecs = []; //для обновления кнопки квитировать
                this.setPm();
                this.setPmHeader();
                this.update();
                break;
        }
    }

    // Кнопка Квитировать на странице
    get isvisiblekvit() {
        return this._isvisiblekvit ?? true
    }
    set isvisiblekvit(value) {
        this._isvisiblekvit = this._toBool(value)
        const acknowledgePageButton = this._toolBar.elements["AcknowledgePage"]
        acknowledgePageButton.style.display = this._isvisiblekvit ? "" : "none";
    }

    get askackcomment() {
        return this._askackcomment;
    }
    set askackcomment(value) {
        this._askackcomment = this._toBool(value);
    }

    get updateperiod() {
        return this.sw.options.updatePeriod;
    }
    set updateperiod(value) {
        this.sw.options.updatePeriod = Number(value);
        this.sw.options.interval = Number(value);
    }

    get interval() {
        return this._interval;
    }
    set interval(value) {
        this._interval = Number(value);
        if (this._usetimefilter) this.Update();
    }

    get tablecolumns() {
        return this._tablecolumns;
    }
    set tablecolumns(value) {
        let decarator = this.getAttribute("fieldstyles");
        try {
            decarator = JSON.parse(decarator);
        } catch (error) {
            decarator = {};
        }

        try {
            this._tablecolumns = JSON.parse(value).column;

            for (const key in decarator) {
                if (key != "Ack") {
                    const element = decarator[key];
                    const index = this._tablecolumns.findIndex(e => {
                        return e.field === key;
                    });
                    if (index < 0) {
                        this._tablecolumns.push({
                            displayname: "",
                            columnwidth: "*",
                            field: key,
                            fieldtype:
                                element[Object.keys(element)[0]].FieldType,
                            valueformat: "",
                            sort: "0",
                            sortposition: 0,
                            visibility: false,
                            horizontalalign: "1",
                        });
                    }
                }
            }
            this._mergeCol(this._tablecolumns);
        } catch (e) {
            this._tablecolumns = null;
        }
        this._calcHeader();
    }

    get filtersbackgroundcolor() {
        return this._filtersbackgroundcolor;
    }
    set filtersbackgroundcolor(value) {
        this._filtersbackgroundcolor = value;
        this._filterDivSet();
    }

    get legendbackgroundcolor() {
        return this._legendbackgroundcolor;
    }
    set legendbackgroundcolor(value) {
        this._legendbackgroundcolor = value;
        if (this._tableLegend) {
            this._tableLegend.style.backgroundColor = this.tryToGetUserColor(this._legendbackgroundcolor);
        }
    }

    get toolbarbackgroundcolor() {
        return this._toolbarbackgroundcolor;
    }
    set toolbarbackgroundcolor(v) {
        this._toolbarbackgroundcolor = v;
        this._toolBar.backgroundcolor = v;
    }

    get fieldstyles() {
        return this._fieldstyles;
    }
    set fieldstyles(value) {
        try {
            this._fieldstyles = JSON.parse(value);
        } catch (e) {
            this._fieldstyles = null;
        }
    }

    get showlegend() {
        return this._showLegend;
    }
    set showlegend(value) {
        this._showLegend = this._toBool(value);
        this.updateLegend();
    }

    get showtoolbar() {
        return this._showtoolbar;
    }
    set showtoolbar(value) {
        this._showtoolbar = this._toBool(value);
        this._toolBar.style.display = this._showtoolbar ? "flex" : "none";
    }

    get autoscroll() {
        return this._autoscroll;
    }

    set autoscroll(value) {
        this._autoscroll = this._toBool(value);
        this._updatePlayBtn();
    }

    get usearchive() {
        return this._usearchive;
    }
    set usearchive(value) {
        const toolbar = this._toolBar;
        this._usearchive = this._toBool(value);
        if (this._usearchive) {
            toolbar.setVisible(toolbar.elements["AcknowledgeAll"], false);
            this._calcHeader();
        } else {
            toolbar.setVisible(toolbar.elements["_showTimeFiltr"], false);
            toolbar.setVisible(toolbar.elements["GoToDate"], false);

            const mark = this._header.querySelector("#mark");
            if (mark) {
                mark.remove();
            }
        }
    }

    get till() {
        this._till;
    }
    set till(value) {
        this._till = Number(value);
        if (this._usetimefilter) this.Update();
    }

    get usetimefilter() {
        return this._usetimefilter;
    }
    set usetimefilter(value) {
        this._usetimefilter = this._toBool(value);
        this._toolBar.setToggleState(
            this._toolBar.elements["_showTimeFiltr"],
            this._usetimefilter
        );
        this._toolBar.setEnable(
            this._toolBar.elements["_onAutoPlayClick"],
            !this._usetimefilter
        );
        if (this._usetimefilter && this._autoscroll) this._onAutoPlayClick();
        this.Update();
    }

    get customFilters() {
        return this._customFilt;
    }
    set customFilters(value) {
        this._customFilt = value;
        for (const key in this._customFilt) {
            const btn = this._header.querySelector(`#${key} .btn`);
            if (btn) {
                const th = btn.parentElement.parentElement;
                this._setThFilterStyle(th, btn);
            }
        }
        this.updateSeverityState();
    }

    get sortOrder() {
        return {
            index: this._cacheSort.index,
            forward: this._cacheSort.forward,
            id: this._cacheSort.id,
        };
    }
    set sortOrder(value) {
        if (this._cacheSort && this._cacheSort.index === value.index) {
            this._cacheSort.forward = value.forward;
        } else {
            const elCont = this._header.querySelector(`th#${value.id}`);
            if (elCont == null) return;
            const el = document.createElement("div");
            elCont.firstChild.insertBefore(el, elCont.firstChild.firstChild);
            this._cacheSort = {
                index: value.index,
                forward: value.forward,
                id: value.id,
                el: el,
            };
        }
        const ico = this._cacheSort.forward
            ? "hmi-j-step-up"
            : "hmi-j-step-down";
        this._cacheSort.el.className = `btn ${ico}`;
        this.update();
    }

    get filter() {
        return this._filter;
    }
    set filter(val) {
        if (this._filter !== val) {
            this._filter = val;
            this._reMonitoredEvents();
        }
    }

    updateAnimations() {
        const flashRows = [];
        for (let row of this._body.children) {
            if (row.classList.contains("flash-animation")) {
                flashRows.push(row);
            }
        }

        const hasListeners = flashRows.some(row => row.hasAttribute('data-animationiteration'));
        if (hasListeners) {
            return;
        }
        const animationIterationListeners = flashRows.map(row => createAnimationIterationListener(row));

        function createAnimationIterationListener(row) {
            return new Promise(function (resolve) {
                row.addEventListener(
                    "animationiteration",
                    function animationIterationComplete() {
                        row.toggleAttribute('data-animationiteration', false);
                        row.removeEventListener("animationiteration", animationIterationComplete);
                        resolve();
                    }
                );
                row.toggleAttribute('data-animationiteration', true);
            });
        }

        Promise.all(animationIterationListeners).then(() => {
            for (let row of this._body.children) {
                row.classList.toggle("flash-animation", row.hasAttribute("data-need-to-animate"));
            }
        });
    }

    localizeDisplayName(el) {
        const displayNameMapping = {
            "Квит": "jornal_ack",
            "Сообщение": "journal_message",
            "Время": "journal_time",
            "Событие": "journal_event",
            "Квитированность": "journal_kvitirovanie",
            "Пользователь": "journal_user",
            "Иконка": "journal_icon",
            "Полное имя объекта": "journal_EventFullObjectName",
            "Объект": "journal_EventObjectName",
            "Источник": "journal_EventSourceName",
            "Источник или объект": "journal_EventSourceOrObjectName",
            "Описание": "journal_EventDescription",
            "Описание или источник": "journal_EventDescriptionOrSource",
            "Состояние": "journal_EventState",
            "Состояние+Приоритет": "journal_EventStateSeverity",
            "IP адрес/Имя устройства": "journal_ClientAddress",
            "IP адрес": "journal_ClientIpAddress",
            "Имя устройства": "journal_ClientHostName",
            "Окно": "journal_window",
            "Внешний источник": "journal_ExternalPath",
            "Время активации": "journal_ActiveTime",
            "Приоритет": "journal_Severity",
            "Активность": "journal_Active",
            "Время деактивации": "journal_InactiveTime",
            "Время квитирования": "journal_AckedTime",
            "Комментарий": "journal_comment",
            "Значение": "journal_value",
            "Максимальная скорость изменения": "journal_MaxChangeRate",
        };
        const translationKey = displayNameMapping[el];
        if (translationKey){
            el = i18next.t(translationKey)
        }
        return el;
    }

    _calcHeader() {
        if (!this._tablecolumns) {
            return;
        }

        const bookmarks =
            this._usearchive && this.isfavorite
                ? '<th id="mark" style="width:20px;box-sizing:border-box;"><div><span class="btn hmi-j-e-marker"></span></div></th>'
                : "";

        let h = this.ischecked
            ? `<th id="check" style="width:20px;box-sizing:border-box;"></th>${bookmarks}`
            : bookmarks;

        const tempTextContainer = this.createTempTextContainer();
        const { fixedColumnsWidth, stars } =
            this.calculateColumnsWidth(tempTextContainer);

        const bordersWidth = this.getAttribute("borderthickness") * 2; // слева и справа две границы
        const oneStar =
            (this.getAttribute("width") - bordersWidth - fixedColumnsWidth) /
            stars;
        document.body.removeChild(tempTextContainer);

        for (let i = 0; i < this._tablecolumns.length; i++) {
            const el = this._tablecolumns[i];
            if (this._toBool(el.visibility)) {
                let btn = "";
                const fl = el.enablefilter ? ' class="btn hmi-j-filter"' : "";
                switch (el.fieldtype) {
                    case "":
                    case "STRING":
                    case "BOOL":
                    case "BYTE":
                    case "INT":
                    case "DINT":
                    case "DATE_AND_TIME":
                    case "DATE":
                    case "TIME":
                    case "LREAL":
                    case "DWORD":
                    case "LWORD":
                    case "WORD":
                    case "REAL":
                    case "LINT":
                    case "SINT":
                    case "UDINT":
                    case "UINT":
                    case "ULINT":
                    case "USINT":
                    case "DT":
                    case "TOD":
                        if (el.field === "Ack") {
                            btn = `<span data-type="BOOL"${fl}></span>`;
                            break;
                        }
                        btn = `<span data-type="${el.fieldtype}"${fl}></span>`;
                        break;
                    default:
                        if (
                            DataTypes.dataTypes[el.fieldtype]?.DataType ===
                            "EnumeratedType"
                        ) {
                            btn = `<span data-type="ENUM" data-enum="${el.fieldtype}"${fl}></span>`;
                        } else {
                            btn = `<span data-type="ENUM" data-enum="${el.fieldtype}"></span>`;
                        }
                }

                if (el.sort != 0) {
                    const i = this._baseFildsDict[el.field];
                    if (i > -1) {
                        this._cacheSort = {
                            index: i,
                            forward: Number(el.sort) === 1,
                            el: null,
                            field: el.field,
                        };
                    }
                }

                const w = parseInt(el.columnwidth)
                    ? parseInt(el.columnwidth) + "px"
                    : (el.columnwidth.split("*").length - 1) * oneStar;
                    el.displayname = this.localizeDisplayName(el.displayname)
                // todo: на бекенде рассчитано, что Acked, а на фронте где-то Ack, а где-то Acked
                // todo: нужно привести к единому виду
                h += `<th align="center" style="width:${w};box-sizing:border-box;" id='${el.field === "Ack" ? "Acked" : el.field
                    }'><div><div>${el.displayname}</div>${btn}</div></th>`;
            }
        }

        this._header.innerHTML = h;
        if (this._cacheSort) {
            const elt = this._header.querySelector(
                `#${this._cacheSort.field}`
            ).firstChild;
            const el = document.createElement("div");
            el.className = !this._cacheSort.forward
                ? "btn hmi-j-step-down"
                : "btn hmi-j-step-up";
            this._cacheSort.el = el;
            elt.insertBefore(el, elt.firstChild);
        }
        this._header.onclick = this._onHeaderClick.bind(this);
        if (bookmarks) {
            this._header.querySelector("#mark").onclick =
                this._onMarksClick.bind(this);
        }
        this._hs = [];
        this.setPmHeader();

        // по прошествию requestAnimationFrame все табы кроме активного будут скрыты посредством display: none,
        // и вычислить позицию внутренних элементов скрытых табов станет невозможным,
        // поэтому нужно сохранить позиции пока табы ещё видимы.
        // И вычислять нужно основываясь на переданных из masterscada значениях,
        // поскольку нативные clientWidth и offsetLeft могут показывать каждый раз разные значения
        const positions = [...this._header.childNodes].reduce(
            (acc, next, i) => acc.concat({
                offsetLeft: i === 0 ? 0 : acc[i - 1].offsetLeft + acc[i - 1].clientWidth,
                clientWidth: parseFloat(next.style.width),
            }),
            []
        );

        if (this.raf) {
            // метод _calcHeader может вызываться несколько раз изменяя количество элементов,
            // при этом надо не забывать отменять предыдущий вызов requestAnimationFrame,
            // поскольку он уже будет неактуальным
            window.cancelAnimationFrame(this.raf);
        }

        this.raf = window.requestAnimationFrame(() => {
            if (!this._table) return;
            let sep = this._table.parentNode.querySelectorAll("div#sp");
            if (sep.length > 0) {
                sep.forEach(element => {
                    element.remove();
                });
                this._hs = [];
            }
            let tw = 0;
            for (let i = 0; i < this._header.childNodes.length; i++) {
                const el = this._header.childNodes[i];
                const { offsetLeft, clientWidth } = positions[i];

                const separator = this.createSeparator(
                    offsetLeft + clientWidth,
                    i === this._header.childNodes.length - 1
                );

                this._table.parentNode.appendChild(separator);

                const index =
                    this._hs.push({
                        l: offsetLeft,
                        w: clientWidth,
                        el,
                        sep: separator,
                    }) - 1;
                tw += clientWidth;
                el.style.width = clientWidth + "px";
                separator._el = this._hs[index];
                separator._index = index;
            }
            this._table.style.width = tw + "px";
        });
    }

    createTempTextContainer() {
        const tempTextContainer = document.createElement("span");
        tempTextContainer.style.fontSize = this.headerrowstyle.fontsize;
        tempTextContainer.style.fontStyle = this._toBool(
            this.headerrowstyle.fontitalic
        )
            ? "italic"
            : "normal";
        tempTextContainer.style.textDecoration = this._toBool(
            this.headerrowstyle.fontunderlined
        )
            ? "underline"
            : "";
        tempTextContainer.style.fontWeight = this._toBool(
            this.headerrowstyle.fontbold
        );
        tempTextContainer.style.fontFamily = '"' + this.headerrowstyle.fontname + '"';
        document.body.appendChild(tempTextContainer);
        return tempTextContainer;
    }

    calculateColumnsWidth(tempTextContainer) {
        let fixedColumnsWidth = 0;

        if (this._usearchive && this.isfavorite) {
            fixedColumnsWidth += 20; // закладываем ширину на столбец избранного (id="mark" с шириной 20px)
        }

        if (this.ischecked) {
            fixedColumnsWidth += 20; // закладываем ширину на столбец с индикатором выбранной строки
        }

        let stars = 0;
        for (const col of this._tablecolumns) {
            if (col.visibility) {
                if (col.columnwidth.toString().startsWith("*")) {
                    stars += col.columnwidth.split("*").length - 1;
                    continue;
                }
                const tSize = Number(col.columnwidth);
                if (Number.isNaN(tSize)) {
                    tempTextContainer.innerText = col.displayname;
                    col.columnwidth =
                        tempTextContainer.getBoundingClientRect().width +
                        (col.field === "Ack" ? 10 : 40);
                    fixedColumnsWidth += col.columnwidth;
                } else {
                    fixedColumnsWidth += tSize;
                }
            }
        }
        return { fixedColumnsWidth, stars };
    }

    createSeparator(pos, isLastCol) {
        const separator = document.createElement("div");
        separator.style.position = "absolute";
        separator.style.top = this._table.offsetTop;
        separator.style.height = "100%";
        const width = 4;
        separator.style.width = `${width}px`;
        separator.style.left = pos - (isLastCol ? width : width / 2);
        separator.style.backgroundColor = "transparent";
        separator.style.cursor = "col-resize";
        separator.style.zIndex = 1;
        separator.id = "sp";
        separator.onmousedown = this.headerSizeMoveStart.bind(this);
        return separator;
    }

    legendSizeMoveStart(e) {
        this._legendSizeTarget = e.target;
        this._legendSizeTarget.style.backgroundColor =
            "rgba(165, 42, 42, 0.19)";

        document.addEventListener("mousemove", this.mouseMoveLegend);
        document.addEventListener("mouseup", this.mouseUpLegend);
    }
    mouseMoveLegend(e) {
        const mainCoords = this.getCoords(this._main);
        const shiftY = mainCoords.top;
        const scale = mainCoords.height / this._main.offsetHeight;
        const newTop = (e.pageY - shiftY) / scale;
        const newHeight = newTop - this._footer.offsetTop;
        this._legendHeight = this._footer.offsetHeight - newHeight;
        this.resizeLegend();
    }
    mouseUpLegend(e) {
        if (this._legendSizeTarget) {
            this._legendSizeTarget.style.backgroundColor = "transparent";
        }

        document.removeEventListener("mousemove", this.mouseMoveLegend);
        document.removeEventListener("mouseup", this.mouseUpLegend);

        this._legendSizeTarget = null;

        return false;
    }

    headerSizeMoveStart(e) {
        this._headerSizetarget = e.target;
        this._headerSizetarget.style.backgroundColor =
            "rgba(165, 42, 42, 0.19)";

        document.addEventListener("mousemove", this.mouseMove);
        document.addEventListener("mouseup", this.mouseUp);

        return false;
    }
    mouseMove(e) {
        const mainCoords = this.getCoords(this._main);
        const shiftX = mainCoords.left;
        const scale = mainCoords.width / this._main.clientWidth;
        const headerSizetargetEl = this._headerSizetarget._el;

        //  вычесть координату родителя, т.к. position: relative
        let newLeft = (e.pageX - shiftX) / scale + this._scrollLeft;
        if (newLeft < headerSizetargetEl.l + 22) {
            newLeft = headerSizetargetEl.l + 22;
        }

        this._headerSizetarget.style.left = newLeft + "px";
        headerSizetargetEl.w = newLeft - headerSizetargetEl.el.offsetLeft;
        headerSizetargetEl.el.style.width = headerSizetargetEl.w + "px";

        let tw = 0;
        for (let index = 0; index < this._hs.length; index++) {
            const element = this._hs[index];
            tw += element.w;
        }

        if (this._table.style.width !== tw + "px") {
            this._table.style.width = tw + "px";
        }
    }

    // Пересчитываем позиции следующих элементов, отталкиваясь от позиции последнего подвинутого пользователем элемента,
    // иначе они останутся прежними и мы не сможем их делать меньше, чем они есть сейчас (т.е. нельзя будет сдвинуть влево)
    updatePositions() {
        const nextElements = this._hs.slice(this._headerSizetarget._index + 1);
        nextElements.forEach((x, i, arr) => {
            const prevEl =
                i === 0 ? this._hs[this._headerSizetarget._index] : arr[i - 1];
            x.l = prevEl.l + prevEl.w + 4;
        });
    }

    mouseUp() {
        if (this._headerSizetarget) {
            this._headerSizetarget.style.backgroundColor = "transparent";
        }

        this.updatePositions();

        document.removeEventListener("mousemove", this.mouseMove);
        document.removeEventListener("mouseup", this.mouseUp);

        for (let index = 0; index < this._hs.length; index++) {
            const element = this._hs[index];
            element.sep.style.left =
                element.el.offsetLeft + element.el.clientWidth + "px";
        }
        this._headerSizetarget = null;
    }

    getCoords(elem) {
        var box = elem.getBoundingClientRect();

        return {
            top: box.top,
            left: box.left,
            width: box.width,
            height: box.height,
        };
    }

    get statusbartextcolor() {
        return this._statusBar.style.color;
    }
    set statusbartextcolor(value) {
        this._statusBar.style.color = this.tryToGetUserColor(value);
    }

    get legendcolumns() {
        return this._legendcolumns;
    }
    set legendcolumns(value) {
        try {
            this._legendcolumns = JSON.parse(value).column;
            if (!Array.isArray(this._legendcolumns)) {
                this._legendcolumns = [this._legendcolumns];
            }
            this._toolBar.setVisible(
                this._toolBar.elements["_onLegendClick"],
                true
            );
            this._mergeCol(this._legendcolumns);
        } catch (e) {
            this._legendcolumns = null;
            this._toolBar.setVisible(
                this._toolBar.elements["_onLegendClick"],
                false
            );
        }
    }

    get requesttimeout() {
        return this._requesttimeout || 60000;
    }
    set requesttimeout(value) {
        const a = Number(value);
        this._requesttimeout = a > 1000 ? a : 1000;
        this.sw.options.timeout = this._requesttimeout;
    }

    get limit() {
        return this._limit || 100;
    }
    set limit(value) {
        const a = Number(value);
        this._limit = a > 100 ? a : 100;
    }

    get rowstyle() {
        return this._rowstyle;
    }
    set rowstyle(value) {
        try {
            this._rowstyle = JSON.parse(value);
        } catch (e) {
            this._rowstyle = null;
        }

        if (this._tableLegend) {
            this._tableLegend.style.fontFamily = '"' + this._rowstyle.fontname + '"';
            this._tableLegend.style.fontSize = this._rowstyle.fontsize;
        }

        let style = "";
        if (this._rowstyle) {
            if (this._rowstyle.backgroundcolor) {
                style += `background-color:${this._rowstyle.backgroundcolor};--bg-color:${this._rowstyle.backgroundcolor};`;
            }
            if (this._rowstyle.bordercolor) {
                style += `border-color:${this._rowstyle.bordercolor};--main-c:${this._rowstyle.bordercolor};`;
            }
            if (this._rowstyle.borderthickness) {
                style += `--main-s:solid none;--main-w:${this._rowstyle.borderthickness}px;border-width:${this._rowstyle.borderthickness}px;border-style: solid;`;
            }
            if (this._rowstyle.fontbold) {
                style += `font-weight:${this._toBool(this._rowstyle.fontbold) ? "bold" : "normal"
                    };`;
            }
            if (this._rowstyle.fontitalic) {
                style += `font-style:${this._toBool(this._rowstyle.fontitalic)
                    ? "italic"
                    : "normal"
                    };`;
            }
            if (this._rowstyle.fontname) {
                style += `font-family:"${this._rowstyle.fontname}";`;
            }
            if (this._rowstyle.fontsize) {
                style += `font-size:${this._rowstyle.fontsize}px;`;
            }
            if (this._rowstyle.fontunderlined) {
                style += `text-decoration:${this._toBool(this._rowstyle.fontunderlined)
                    ? "underline"
                    : "none"
                    };`;
            }
            if (this._rowstyle.textcolor) {
                style += `color:${this._rowstyle.textcolor};`;
            }

            if (Number(this._rowstyle.height)) {
                style += `height:${this._rowstyle.height}px;`;
            } else {
                style += `min-height:24px;height:24px;`;
            }
        }

        this._rowsstyle.innerHTML = `
            :host .jr tbody tr {
                ${style}
            }
            :host .jr tbody tr td {
                border-width: var(--main-w);
                border-style: var(--main-s);
                border-color: var(--main-c);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            :host .jr tbody tr:not(.flash-animation) td {
            background-color: var(--bg-color);
            }
        `;
    }

    get headerrowstyle() {
        if (!this._headerrowstyle) {
            try {
                this._headerrowstyle = JSON.parse(
                    this.getAttribute("headerrowstyle")
                );
            } catch (e) {
                this._headerrowstyle = null;
            }
        }
        return this._headerrowstyle;
    }
    set headerrowstyle(value) {
        try {
            this._headerrowstyle = JSON.parse(value);
        } catch (e) {
            this._headerrowstyle = null;
        }

        let style = "";
        if (this._headerrowstyle) {
            if (this._headerrowstyle.backgroundcolor) {
                style += `background-color:${this._headerrowstyle.backgroundcolor};`;
            }
            if (this._headerrowstyle.bordercolor) {
                style += `border-color:${this._headerrowstyle.bordercolor};`;
            }
            if (this._headerrowstyle.borderthickness) {
                style += `border-width:${this._headerrowstyle.borderthickness};border-style: solid;`;
            }
            if (this._headerrowstyle.fontbold) {
                style += `font-weight:${this._toBool(this._headerrowstyle.fontbold)
                    ? "bold"
                    : "normal"
                    };`;
            }
            if (this._headerrowstyle.fontitalic) {
                style += `font-style:${this._toBool(this._headerrowstyle.fontitalic)
                    ? "italic"
                    : "normal"
                    };`;
            }
            if (this._headerrowstyle.fontname) {
                style += `font-family:"${this._headerrowstyle.fontname}";`;
            }
            if (this._headerrowstyle.fontsize) {
                style += `font-size:${this._headerrowstyle.fontsize}px;`;
            }
            if (this._headerrowstyle.fontunderlined) {
                style += `text-decoration:${this._toBool(this._headerrowstyle.fontunderlined)
                    ? "underline"
                    : "none"
                    };`;
            }
            if (this._headerrowstyle.textcolor) {
                style += `color:${this._headerrowstyle.textcolor};`;
            }

            if (Number(this._headerrowstyle.height)) {
                style += `height:${this._headerrowstyle.height}px;`;
            }
        }

        this._headerstyle.innerHTML = `
            :host .jr th {
                ${style}
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        `;
    }

    /**
     * Группировка фильтров.
     * "0" - ИЛИ
     * "1" - И
    */
    get filterscombinetype() {
        return this._filtersCombineType ?? "1";
    }
    set filterscombinetype(value) {
        this._filtersCombineType = value;
    }

    get filters() {
        return this._filters;
    }
    set filters(value) {
        try {
            if (typeof value === "string") {
                this._filters = JSON.parse(value).filter;
            } else {
                if (Array.isArray(this._filters) && this._filters.length) {
                    const resultFilters = this._filters.map(projFilter => {
                        const filtersInStorage = value.filter(
                            storageFilter =>
                                storageFilter["displayname"] ===
                                projFilter["displayname"]
                        );
                        if (
                            filtersInStorage.length === 1 &&
                            projFilter["candisable"]
                        ) {
                            // проверяем количество фильтров в хранилище и проверяем может ли пользователь изменять фильтр в RT
                            return Object.assign({}, projFilter, {
                                enabled: filtersInStorage[0]["enabled"],
                            });
                        }
                        return projFilter;
                    });
                    this._filters = resultFilters;
                    this.saveItemState({ filters: this._filters }); // обновляем хранилище с фильтрами
                }

                if (this._filterDiv) {
                    this._filterDiv.firstChild.innerHTML =
                        this._generateFilterList();
                }
            }
            if (
                typeof this._filters === "object" &&
                !Array.isArray(this._filters)
            ) {
                this._filters = [this._filters];
            }
            this._toolBar.setVisible(
                this._toolBar.elements["_onFilterClick"],
                true
            );
        } catch (e) {
            this._filters = null;
            this._toolBar.setVisible(
                this._toolBar.elements["_onFilterClick"],
                false
            );
        }
    }

    get objectuid() {
        return this._objectuid;
    }
    set objectuid(value) {
        this._objectuid = Number(value);
        if (typeof value === "string" && Number.isNaN(this._objectuid))
            this._objectuid = value;

        this._reMonitoredEvents();
    }

    get archiveref() {
        return this._archiveref;
    }
    set archiveref(value) {
        this._archiveref = Number(value);
        this.updateArchivedEvents(true);
    }

    get showfilter() {
        return this._showfilter;
    }
    set showfilter(value) {
        this._showfilter = this._toBool(value);
        this._onFilterClick(null, this._showfilter);
    }

    get isglobal() {
        return this._isglobal;
    }
    set isglobal(value) {
        this._isglobal = this._toBool(value);
    }

    // Отвечает за отображение столбца с индикатором выбранной строки
    get ischecked() {
        return this._ischecked ?? true;
    }
    set ischecked(value) {
        const newVal = this._toBool(value);
        const isValueChanged = this._ischecked !== newVal;
        this._ischecked = newVal;

        if (isValueChanged) {
            this._calcHeader();
        }
    }

    // Отвечает за отображение столбца избранного
    get isfavorite() {
        return this._isfavorite ?? false;
    }
    set isfavorite(value) {
        const newVal = this._toBool(value);
        const isValueChanged = this._ischecked !== newVal;
        this._isfavorite = newVal;

        if (isValueChanged) {
            this._calcHeader();
        }
    }

    get hasobjecttree() {
        return this._hasobjecttree;
    }
    set hasobjecttree(value) {
        this._hasobjecttree = this._toBool(value);
        this._toolBar.setVisible(
            this._toolBar.elements["OpenObjectTree"],
            this._hasobjecttree
        );
    }

    /**
    * Уровень вложенности при которой,
    * Если 0 - то дерево полностью открыто,
    * Если 1 - то открыты только корневые элементы,
    * И так далее
    * @type {number}
    */
    get expandedlevel() {
        return this._expandedLevel || 0;
    }

    set expandedlevel(v) {
        this._expandedLevel = +v;
    }

    get showstatusbar() {
        return this._showStatusBar;
    }
    set showstatusbar(value) {
        this._showStatusBar = this._toBool(value);
        if (this._usearchive && this._autoscroll) {
            this._statusBar.style.display = "none";
        } else {
            this._statusBar.style.display = this._showStatusBar
                ? "block"
                : "none";
        }
    }

    get showverticalscrollbar() {
        return this._showVerticalScrollBar;
    }
    set showverticalscrollbar(value) {
        this._showVerticalScrollBar = this._toBool(value);
        this.updateVerticalScrollBar();
    }

    // Формат имени экспорта
    get exportnameformat() {
        return (
            this._exportNameFormat || "{Name}_{yyyy}-{MM}-{dd}-{HH}_{mm}_{ss}"
        );
    }
    set exportnameformat(value) {
        this._exportNameFormat = value;
    }

    // Контейнер для открытия окна объекта
    // "0" - Контейнер стартового окна
    // "1" - Всплывающее окно
    // "2" - Заданный контейнер
    get windowopeningcontainer() {
        return this._windowopeningcontainer ?? 0;
    }
    set windowopeningcontainer(value) {
        this._windowopeningcontainer = +value;
    }

    // Заданный контейнер для открытия окон объектов
    get containerforopeningobjectwindows() {
        return this._containerforopeningobjectwindows;
    }
    set containerforopeningobjectwindows(value) {
        this._containerforopeningobjectwindows = value;
    }

    updateVerticalScrollBar() {
        this._table.parentElement.style.overflow = this._showVerticalScrollBar
            ? "auto"
            : "auto hidden";
    }

    _mergeCol(colums, mergeType) {
        const compare = (name, type, ind) => {
            let i;
            if (name == "Ack") {
                i = 1;
            } else {
                i = this._baseFildsDict[name];
            }

            if (i == undefined) {
                const t =
                    type &&
                        DataTypes.dataTypes[type] &&
                        DataTypes.dataTypes[type].DataType === "EnumeratedType"
                        ? "INT"
                        : type;
                const newIndex = this._baseFilds.push({ name: name, type: t });
                if (ind != undefined) {
                    this._baseFildsDict[name] = colums[ind]["baseIndex"] =
                        newIndex - 1;
                }
            } else {
                if (ind != undefined)
                    colums[ind]["baseIndex"] = this._baseFildsDict[name];
            }
        };
        if (mergeType) {
            for (const key in colums) {
                const element = colums[key];
                compare(key, element[Object.keys(element)[0]].FieldType);
            }
        } else {
            for (let ind = 0; ind < colums.length; ind++) {
                const element = colums[ind];
                if (typeof element.fieldtype != "undefined") {
                    compare(element.field, element.fieldtype, ind);
                }
            }
        }
    }

    connectedCallback() {
        if (typeof this.saveStateFlag === "undefined") {
            this.saveStateFlag = this.calcSaveState();
        }
        if (this.saveStateFlag) {
            this.updateItemState();
        }
        if (this._usetimefilter && this._autoscroll) this._onAutoPlayClick();
        this.updateStatusBar();
        this._start = true;
        this.Update();
        this.sw
            .Subscribe()
            .then(this._createMonitoredEvents.bind(this))
            .then(this.sw.StartWatch.bind(this.sw));
    }

    async disconnectedCallback() {
        for (let i = 0; i < this._hs.length; i++) {
            const el = this._hs[i];
            el.sep.onmousedown = null;
            el.sep = null;
            el.el = null;
        }
        this._hs = null;
        if (this._cacheSort && this._cacheSort.el) {
            this._cacheSort.el.remove();
            this._cacheSort.el = null;
            delete this._cacheSort.el;
        }
        this._body.onclick = null;
        this._body.ondblclick = null;
        this._body.innerHTML = "";
        this._body.remove();
        // this._body.children
        delete this._body;
        delete this._filterDiv;
        delete this._footer;
        delete this._header;
        delete this._toolBar;
        delete this._table;
        delete this._headerrowstyle;
        delete this._headerstyle;
        delete this._statusBar;
        delete this._main;
        delete this._rowsstyle;
        delete this._sortRecs;
        delete this._recs;
        delete this._tableLegend;
        window.removeEventListener("ms_message", this.afterSwitch);
        this.sw.StopWatch();
        if (this.monitoredItemId) {
            await this.sw.DeleteMonitoredEvents(this.monitoredItemId);
            delete this.monitoredItemId;
        }
        this.sw.ServerAdapter.dispose();
        this.mouseMove = null;
        this.mouseUp = null;
        super.disconnectedCallback();
    }

    _getItemId() {
        let result = {};
        if (!this._isglobal) {
            if (this._objectuid === 0) {
                result.itemId = $sw.ItemSubscription._getParentParam(
                    this,
                    "objectid",
                    true
                );
                result.taskId = $sw.ItemSubscription._getParentParam(
                    this,
                    "taskid",
                    true
                );
                result.path = $sw.ItemSubscription._getOuterPath(this);
            } else if (typeof this._objectuid === "string") {
                result.itemId = 0;
                result.path = this._objectuid;
            } else {
                result.itemId = this._objectuid;
            }
        }
        return result;
    }

    _calcFilters() {
        if (!this._toolBar) return;
        const res = this.createFilters();
        const active = res.length > 0;
        this._toolBar.setToggleState(
            this._toolBar.elements["_onFilterClick"],
            active
        );

        const obj_res = [];

        this._sources.forEach(el => {
            let name = $pr.getFullNameIfInInstance(el);
            if (name) {
                obj_res.push(`EventFullObjectName :> '${name}'`);
            } else {
                obj_res.push(`ItemId :> ${el}`);
            }
        });
        if (obj_res.length > 0) {
            res.push(obj_res.join(" or "));
        }

        for (const key in this._customFilt) {
            if (this._customFilt.hasOwnProperty(key)) {
                const el = this._customFilt[key];
                switch (el.type) {
                    case "STRING":
                        res.push(`${key} Contains "${el.value}"`);
                        break;
                    case "BOOL":
                        res.push(`${key} == ${el.value}`);
                        break;
                    case "ENUM":
                        let t = [];
                        for (let i = 0; i < el.value.length; i++) {
                            const e = el.value[i];
                            if (e) {
                                t.push(`${key} == ${i}`);
                            }
                        }
                        if (t.length > 0) res.push(t.join(" or "));
                        break;
                    case "NUMBER":
                        if (el.value.min) {
                            res.push(`${key} >= ${el.value.min}`);
                        }
                        if (el.value.max) {
                            res.push(`${key} <= ${el.value.max}`);
                        }
                        break;
                    case "DATE_AND_TIME":
                        if (el.value.min) {
                            res.push(
                                `${key} >= ${el.value.min * 10000 + 116444736000000000
                                }`
                            );
                        }
                        if (el.value.max) {
                            res.push(
                                `${key} <= ${el.value.max * 10000 + 116444736000000000
                                }`
                            );
                        }
                        break;
                }
            }
        }
        return this.filter ? res.concat(JSON.parse(this.filter)) : res;
    }

    createFilters() {
        const filters = this._filters.reduce((acc, { enabled, condition }) =>
            this._toBool(enabled) ? acc.concat(condition) : acc, []);
        return this.filterscombinetype == 0 ? [filters.join(" or ")] : filters;
    }

    async _createMonitoredEvents() {
        let packet = {
            clientHandle: this._clientHandle++,
            fields: this._baseFilds,
            filter: this._calcFilters(),
            path: "",
            taskId: 0,
        };
        if (this._usearchive) {
            packet.useArchive = true;
        }
        if (typeof this._archiveref != "undefined")
            packet.archiveId = this._archiveref;

        packet = Object.assign(packet, this._getItemId());

        return await this.sw.CreateMonitoredEvents([packet]).then(data => {
            this._busyMonitoredEvents = false;
            this.monitoredItemId = data.items[0].monitoredItemId;
            if (this.needReCreate) {
                this.needReCreate = false;
                this._reMonitoredEvents();
                return;
            }
            this.sw.RefreshEvents();
            if (this._usearchive) {
                this.updateArchivedEvents(true);
            } else {
                this.Clear();
            }
        });
    }

    updateArchivedEvents(inverse) {
        let start = 0,
            end = 0;
        if (this._usetimefilter) {
            start = this._till - this._interval;
            end = this._till;
        }
        this._getArchived(start, end, inverse);
    }

    async _getArchived(timeStart, timeEnd, inverse) {
        if (!this._start) return;

        if (!this._autoscroll) {
            this.refreshArchivedRecs = true;
        }

        let packet = {
            inverse: inverse,
            endTime: timeEnd,
            fields: this._baseFilds,
            filter: this._calcFilters(),
            maxRecs: this.limit,
            maxSize: 0,
            path: "",
            startTime: timeStart,
        };
        if (typeof this._archiveref != "undefined")
            packet.archiveId = this._archiveref;

        packet = Object.assign(packet, this._getItemId());

        return this.sw
            .getArchivedEvents(packet)
            .then(({ code, recs }) => {
                if (code != 0) {
                    if (code === 0x809B0000) { // OpcUa_BadNoData
                        $ns.add({
                            type: 'error',
                            time: new Date().toLocaleString(),
                            title: `${i18next.t('opcUa_BadNoData_title')}`,
                            text: String.format(i18next.t("opcUa_BadNoData_text"), this._elname),
                        });
                    }

                    console.log(code.toString(16));
                    return;
                }

                if (recs) {
                    const refreshAllRecs = this.refreshArchivedRecs;
                    this.refreshArchivedRecs = true;
                    if (!this._recs.length || refreshAllRecs) {
                        this._recs = recs;
                    } else {
                        const updatedRecs = this._recs.map(oldRec => {
                            // Сравниваем по EventId
                            const equalRec = recs.find(newRec => newRec.length === oldRec.length && newRec[3] === oldRec[3]);
                            return equalRec || oldRec
                        });

                        const newRecs = recs.filter(newRec =>
                            !updatedRecs.find(oldRec =>
                                oldRec.length === newRec.length && oldRec[3] === newRec[3] // Сравниваем по EventId
                            )
                        );

                        this._recs = updatedRecs
                            .concat(newRecs)
                            .sort((a, b) => (b[4] - a[4])) // сортируем по времени
                            .slice(0, this.limit)
                    }

                    if (!inverse) {
                        this._recs.reverse();
                    }

                    this.update();
                    if (inverse) {
                        this._table.parentElement.scrollTop = 0;
                    } else {
                        this._table.parentElement.scrollTop =
                            this._table.parentElement.scrollHeight -
                            this._table.parentElement.clientHeight;
                    }
                } else {
                    this.Clear();
                }
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    _upData(ans) {
        let isChanged = false;
        let isSkipChanged = false;
        let shift = 0;
        if (typeof this._recs !== "undefined") {
            const recs = ans.recs
                ? ans.recs.sort((a, b) => a.fields[4] - b.fields[4]) || []
                : [];
            const del = ans.deleted || [];
            for (let index = 0; index < recs.length; index++) {
                const element = recs[index];

                let last_greater = -1;
                const i = this._recs.findIndex((item, ind) => {
                    if (this._usearchive) {
                        if (item[4] > element.fields[4]) last_greater = ind;
                        return item[3] === element.fields[3];
                    } else
                        return (
                            item[3].substr(13) === element.fields[3].substr(13)
                        );
                });
                switch (element.recType) {
                    case "Update":
                        if (this._usearchive) {
                            //Now always UpdateArchive
                            //    if (this._first && this._autoscroll) {
                            //        this._recs.splice(0, 0, element.fields);
                            //        if (
                            //            this._recs.length > this.limit &&
                            //            this._usearchive
                            //        ) {
                            //            this._recs.pop();
                            //        }
                            //    } else {
                            //        this._skip++;
                            //        isSkipChanged = true;
                            //    }
                        } else {
                            if (i < 0) {
                                this._recs.push(element.fields);
                            } else {
                                this._recs[i] = element.fields;
                            }
                        }

                        break;
                        case "UpdateArchive":
                            if (this._usearchive) {
                                if (i >= 0) {
                                    this._recs[i] = element.fields;
                                } else if (this._autoscroll) {
                                    if (
                                        last_greater < this._recs.length - 1 ||
                                        this._recs.length < this.limit
                                    ) {
                                        this._recs.splice(
                                            last_greater + 1,
                                            0,
                                            element.fields
                                        );
                                        if (this._recs.length > this.limit) {
                                            this._recs.pop();
                                        }
                                    }
                                } else {
                                    this._skip++;
                                    isSkipChanged = true;
                                }
                            }
                            break;
                    case "Refresh":
                        if (i < 0) {
                            if (!this._usearchive) {
                                this._recs.push(element.fields);
                            } else {
                                //console.log(2, element.fields[16]);
                            }
                        } else {
                            this._recs[i] = element.fields;
                        }
                        break;
                    case "Acknowledge":
                        break;
                }
                isChanged = true;
            }

            for (let index = 0; index < del.length; index++) {
                const element = del[index];
                element.eventIds.forEach(el => {
                    const i = this._recs.findIndex(item => {
                        if (this._usearchive) return item[3] === el;
                        else return item[3].substr(13) === el.substr(13);
                    });
                    if (i > -1) {
                        this._recs.splice(i, 1);
                    }
                });
                isChanged = true;
            }
        }

        if ((isSkipChanged || isChanged) && !this.isVisibleFromRoot) {
            this._updateWhenVisible = true;
            return;
        }

        if (isSkipChanged || isChanged || this._updateWhenVisible)
            this.updateStatusBar();

        if (isChanged || this._updateWhenVisible) {
            this._updateWhenVisible = false;
            let scroll = 0;

            if (shift) {
                scroll = this._table.parentElement.scrollTop;
            }

            this.update();

            if (shift) {
                const offset = this._body.firstChild.offsetHeight * shift;
                this._table.parentElement.scrollTop = scroll + offset;
            }
        }
    }

    /**
     * Renderer body table
     *
     * @memberof MSJournal
     */
    update() {
        if (!this._body) return;

        const isJournalAckDisabled = $pm.isPermDisabled(this, "JournalAck");

        const hAlign = {
            0: "left",
            1: "center",
            2: "right",
        };

        this.updateLegend();

        if (this._cacheSort && !this._usearchive) {
            if (this._cacheSort.index > -1) {
                this._baseFilds[this._cacheSort.index];
                this._sortRecs = Array.from(this._recs);
                this._sortRecs.sort((a, b) => {
                    const iA =
                        typeof a[this._cacheSort.index] === "string"
                            ? a[this._cacheSort.index].toLowerCase()
                            : a[this._cacheSort.index];
                    const iB =
                        typeof b[this._cacheSort.index] === "string"
                            ? b[this._cacheSort.index].toLowerCase()
                            : b[this._cacheSort.index];
                    if (iA < iB) return -1;
                    if (iA > iB) return 1;
                    return 0;
                });
            }
            if (!this._cacheSort.forward) {
                this._sortRecs.reverse();
            }
        } else {
            this._sortRecs = this._recs;
        }
        const countRecs =
            this._usearchive || this._sortRecs.length <= this.limit
                ? this._sortRecs.length
                : this.limit;
        if (countRecs < this._body.childNodes.length) {
            const count = this._body.childNodes.length - countRecs;
            for (let i = 0; i < count; i++) {
                this._body.lastChild.remove();
            }
        }

        const timeOffset = new Date().getTimezoneOffset() * 60000;
        for (let index = countRecs; index < this._curTableRecs.length; index++)
            this._curTableRecs[index] = null;

        for (let index = 0; index < countRecs; index++) {
            const element = this._sortRecs[index];
            if (index < this._curTableRecs.length) {
                const oldElem = this._curTableRecs[index];
                if (
                    oldElem != null &&
                    element[3] === oldElem[3] &&
                    element[1] === oldElem[1] &&
                    element[2] === oldElem[2]
                )
                    //compare id, active, acked
                    continue;
            }
            this._curTableRecs[index] = [
                element[0],
                element[1],
                element[2],
                element[3],
            ];

            let offset = 0;
            const tr = this._getRow(index);
            tr.removeAttribute("style");

            if (this.ischecked) {
                const marker = this._getCol(tr, offset++);
                if (this._select.rec && element[3] == this._select.rec[3]) {
                    marker.innerHTML = this._marker();
                } else if (marker.innerHTML != "") {
                    marker.innerHTML = "";
                }
            }

            if (this._usearchive && this.isfavorite) {
                const bookmark = this._getCol(tr, offset++);
                bookmark.setAttribute("smark", "");
                if (this._bookmarks[element[3]]) {
                    bookmark.innerHTML =
                        '<span align="center" style="pointer-events: none; font-size: medium;" class="btn hmi-j-f-marker"></span>';
                } else {
                    bookmark.innerHTML = "";
                }
            }

            if (this._usearchive && element[5] !== 1) {
                element[1] = true;
            }

            for (let i = 0; i < this._tablecolumns.length; i++) {
                const col = this._tablecolumns[i];
                const td = this._getCol(tr, offset++);
                if (!col.visibility) {
                    td.innerHTML = "";
                    continue;
                }
                td.setAttribute("align", hAlign[col.horizontalalign]);
                switch (col.field) {
                    case "Ack":
                        if (!element[col.baseIndex]) {
                            td.innerHTML = `<button class="ack" id="${element[3]}"${isJournalAckDisabled ? " disabled" : ""}>${i18next.t('jornal_ack')}</button>`;
                        } else {
                            if (col.valueformat) {
                                const val =
                                    element[8] !== 0
                                        ? _df.dateFormat(
                                            element[8],
                                            col.valueformat
                                        )
                                        : "";
                                td.innerHTML = val;
                            } else if (td.innerHTML != "") {
                                td.innerHTML = "";
                            }
                        }
                        break;
                    case "Icon":
                        const path = `_event_${element[0]}`;
                        const res = this.getResourceFromList(path);
                        if (path !== res) {
                            td.innerHTML = `<img src="resources/${res}" style="width: 20px;display: block;"></img>`;
                        } else {
                            td.innerHTML = "";
                        }
                        break;
                    case "WindowId":
                        const [WindowID, ObjectId, FullOuterPath] = this.parseWindowDataStr(element[col.baseIndex]);
                        if (WindowID && WindowID !== "0") {
                            td.innerHTML = `<button class="windowIdLinkBtn" type="button">${i18next.t("open")}</button>`;
                            td.querySelector('button').addEventListener('click', (e) => {
                                e.stopPropagation();
                                const action = this.createActionForWindow(e.target, WindowID, ObjectId, FullOuterPath);
                                action.execute(e);
                            })
                        } else {
                            td.innerHTML = '';
                        }
                        break;
                    default:
                        if (typeof element[col.baseIndex] != "undefined") {
                            let isDT = false;
                            switch (col.fieldtype) {
                                case "DT":
                                case "DATE_AND_TIME":
                                    if (!col.valueformat)
                                        col.valueformat = "dd.MM.yyyy HH:mm:ss";
                                    //if (element[col.baseIndex]) element[col.baseIndex] -= timeOffset;
                                    isDT = true;
                                    break;
                                case "DATE":
                                    if (!col.valueformat)
                                        col.valueformat = "dd.MM.yyyy";
                                    //if (element[col.baseIndex]) element[col.baseIndex] -= timeOffset;
                                    isDT = true;
                                    break;
                                case "TIME":
                                case "TOD":
                                case "TIME_OF_DAY":
                                    if (element[col.baseIndex])
                                        element[col.baseIndex] += timeOffset;
                                    if (!col.valueformat)
                                        col.valueformat = "HH:mm:ss";
                                    isDT = true;
                                    break;
                            }
                            if (isDT) {
                                const val =
                                    element[col.baseIndex] !== 0
                                        ? _df.dateFormat(
                                            element[col.baseIndex],
                                            col.valueformat
                                        )
                                        : "";
                                td.innerHTML = val;
                            } else if (
                                Object.keys(this.enums(col.fieldtype) || {})
                                    .length > 0
                            ) {
                                td.innerHTML = this.enums(col.fieldtype)[
                                    parseInt(element[col.baseIndex])
                                ];
                                switch (td.innerHTML) {
                                    case "Появление":
                                        td.innerHTML = i18next.t("journal_appearance")
                                    break;
                                    case "Исчезновение":
                                        td.innerHTML = i18next.t("journal_disappearance")
                                    default: td.innerHTML
                                }
                            } else {
                                let formatVal;
                                if (col.valueformat) {
                                    try {
                                        formatVal = getFormattedValue(
                                            col.valueformat,
                                            element[col.baseIndex].toString()
                                        );
                                    } catch (error) {
                                        formatVal = element[col.baseIndex];
                                    }
                                } else {
                                    formatVal = element[col.baseIndex];
                                }
                                td.innerHTML = formatVal;
                            }
                        }
                }
            }

            const filds = this._fieldstyles
                ? Object.keys(this._fieldstyles)
                : [];
            if (!this._fieldstylesDict) this._fieldstylesDict = {};
            if (filds.length > 0) {
                for (let inf = 0; inf < filds.length; inf++) {
                    const filKey = filds[inf];
                    if (!this._fieldstylesDict[filKey]) {
                        this._fieldstylesDict[filKey] =
                            this._baseFildsDict[filKey];
                    }
                    for (const k in this._fieldstyles[filKey]) {
                        if (this._fieldstyles[filKey].hasOwnProperty(k)) {
                            const el = this._fieldstyles[filKey][k];
                            const resault = Converter.convert(
                                el,
                                element[this._fieldstylesDict[filKey]],
                                el.FieldType
                            );
                            switch (k) {
                                case "FontItalic":
                                    if (resault) {
                                        tr.style.fontStyle = "italic";
                                    }
                                    break;
                                case "FontBold":
                                    if (resault) {
                                        tr.style.fontWeight = "bold";
                                    }
                                    break;
                                case "FontUnderlined":
                                    if (resault) {
                                        tr.style.textDecoration = "underline";
                                    }
                                    break;

                                case "TextColor":
                                    if (resault) {
                                        tr.style.color = this.tryToGetUserColor(resault);
                                    }
                                    break;
                                case "FontSize":
                                    if (resault) {
                                        tr.style.fontSize = `${resault}px`;
                                    }
                                    break;
                                case "FontName":
                                    if (resault) {
                                        tr.style.fontFamily = '"' + resault + '"';
                                    }
                                    break;
                                case "BackgroundColor":
                                    if (resault) {
                                        tr.style.setProperty('--bg-color', this.tryToGetUserColor(resault))
                                    }
                                    break;
                                case "BorderColor":
                                    if (resault) {
                                        tr.style.setProperty("--main-c", this.tryToGetUserColor(resault));
                                    }
                                    break;
                                case "BorderThickness":
                                    if (resault) {
                                        tr.style.setProperty(
                                            "--main-w",
                                            resault
                                        );
                                    }
                                    break;
                                case "Flash":
                                    tr.toggleAttribute("data-need-to-animate", resault);
                                    this.updateAnimations();
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                }
            }
            tr.id = element[3];
        }
        if (this._select.rec && this._select.rec[3]) {
            const el = this._body.querySelector(`[id="${this._select.rec[3]}"`);
            if (el) {
                this._select.td = el.firstChild;
            }
        }
        this.updateStatusBar();
        requestAnimationFrame(() => {
            if (this._table) {
                this.updateVerticalScrollBar();
            }
        });
    }

    _getRow(index) {
        if (this._body.children[index]) {
            return this._body.children[index];
        } else {
            const tr = document.createElement("tr");
            this._body.appendChild(tr);
            return tr;
        }
    }

    _getCol(row, index) {
        if (row.children[index]) {
            return row.children[index];
        } else {
            const td = document.createElement("td");
            row.appendChild(td);
            return td;
        }
    }

    parseWindowDataStr(windowDataStr) {
        const slashIndex = windowDataStr.indexOf('/');
        if (slashIndex !== -1) {
            const WindowID = windowDataStr.slice(0, slashIndex);
            const windowParams = windowDataStr.slice(slashIndex + 1);
            const dotIndex = windowParams.indexOf(".");
            if (dotIndex !== -1) {
                const ObjectId = windowParams.slice(0, dotIndex);
                const FullOuterPath = windowParams.slice(dotIndex + 1);
                return FullOuterPath.charAt(FullOuterPath.length - 1) !== "."
                    ? [WindowID, ObjectId, FullOuterPath + '.']
                    : [WindowID, ObjectId, FullOuterPath]
            }
            return [WindowID, windowParams];
        }
        return [windowDataStr];
    }

    createActionForWindow(target, WindowID, ObjectId, FullOuterPath) {
        switch (this.windowopeningcontainer) {
            case 0: {
                return new ActionFactory(
                    {
                        type: "OpenWindow",
                        WindowID,
                        ObjectId,
                        FullOuterPath,
                        TaskId: -1,
                    },
                    target
                );
            }
            case 1: {
                return new ActionFactory(
                    {
                        type: "OpenDialog",
                        WindowID,
                        ObjectId,
                        FullOuterPath,
                        TaskId: -1,
                        CanClose: true,
                        Text: "",
                        SizeToContent: 0, // Нужно, чтобы модальное окно было того же размера, которое оно отображает
                        parameters: {} // Нужно, чтобы не падали ошибки в коде
                    },
                    target
                );
            }
            case 2: {
                return new ActionFactory(
                    {
                        type: "OpenWindow",
                        FrameId: this.containerforopeningobjectwindows,
                        WindowID,
                        ObjectId,
                        FullOuterPath,
                        TaskId: -1,
                    },
                    target
                );
            }
            default: {
                throw new Error(`Expected 0, 1 or 2, but got incorrect windowopeningcontainer value: ${this.windowopeningcontainer}`)
            }
        }
    }

    updateLegend() {
        if (!this._legendcolumns) return;
        this._toolBar.setToggleState(
            this._toolBar.elements["_onLegendClick"],
            this._showLegend
        );
        if (this._showLegend) {
            this._footer.style.display = "flex";
            let trsLegend = "";

            for (let i = 0; i < this._legendcolumns.length; i++) {
                const col = this._legendcolumns[i];
                if (col.visibility) {
                    let value = this._select.rec
                        ? this._select.rec[col.baseIndex]
                        : "";
                    let isDT = false;
                    switch (col.fieldtype) {
                        case "DATE_AND_TIME":
                            if (!col.valueformat)
                                col.valueformat = "dd.MM.yyyy HH:mm:ss";
                            isDT = true;
                            break;
                        case "DATE":
                            if (!col.valueformat)
                                col.valueformat = "dd.MM.yyyy";
                            isDT = true;
                            break;
                        case "TIME":
                            if (!col.valueformat) col.valueformat = "HH:mm:ss";
                            isDT = true;
                            break;
                        default:
                            if (
                                Object.keys(this.enums(col.fieldtype) || {})
                                    .length > 0
                            ) {
                                value = this.enums(col.fieldtype)[
                                    parseInt(value)
                                ];
                            }
                    }
                    switch (col.displayname) {
                        case "Время":
                            col.displayname = i18next.t("journal_time");
                            break;
                        case "Сообщение":
                            col.displayname = i18next.t("journal_message");
                            break;
                        case "Приоритет":
                            col.displayname = i18next.t("journal_priority");
                            break;
                        case "Время снятия":
                            col.displayname = i18next.t("journal_withdrawal_time");
                            break;
                        case "Время квитирования":
                            col.displayname = i18next.t("journal_kvit_time");
                            break;
                        case "Пользователь":
                            col.displayname = i18next.t("journal_user");
                            break;
                        case "Комментарий": 
                            col.displayname = i18next.t("journal_comment");
                            break;
                        case "Время активации":
                            col.displayname = i18next.t("journal_activation_time");
                            break;

                        default: col.displayname;
                    }
                    value =
                        isDT && value != 0
                            ? _df.dateFormat(value, col.valueformat)
                            : value;
                    let align;
                    switch (col.horizontalalign) {
                        default:
                        case "0":
                            align = 'style="text-align: left;"';
                            break;
                        case "1":
                            align = 'style="text-align: center;"';
                            break;
                        case "2":
                            align = 'style="text-align: right;"';
                            break;
                    }
                    if (col.field === "Icon" && this._select.rec) {
                        const path = `_event_${this._select.rec[0]}`;
                        const res = this.getResourceFromList(path);
                        if (path !== res) {
                            value = `<img src="resources/${res}" style="width: 20px;"></img>`;
                        }
                    }
                    trsLegend += `<tr><td>${col.displayname}</td><td ${align}>${value}</td></tr>`;
                }
            }

            if (!this._tableLegend) {
                this._tableLegend = document.createElement("table");
                this._tableLegend.classList.add("legend");
                this._tableLegend.style.width = "100%";
                this._tableLegend.style.borderSpacing = "0";
                if (this._rowstyle) {
                    this._tableLegend.style.fontFamily =
                        this._rowstyle.FontName;
                    this._tableLegend.style.fontSize = this._rowstyle.FontSize;
                }
                this._tableLegend.style.backgroundColor =
                    this._legendbackgroundcolor;
                this._footer.innerHTML = `
                    <style> 
                        :host table.legend tr{height: 1.5em;}
                        :host table.legend td{border-top: 1px dashed #23274c21;}
                        :host table.legend td:first-child{width: max-content; white-space: nowrap;padding: 0 10px;}
                        :host table.legend td:last-child{width: 100%;}
                    </style>
                    <div style="position:absolute;left:0;right:0;height:5px;z-index:2;cursor:row-resize;"></div>
                `;
                this._tableLegendSeparator = this._footer.querySelector('div');
                this._tableLegendSeparator.onmousedown = this.legendSizeMoveStart.bind(this);
                this._footer.appendChild(this._tableLegend);
            }
            this._tableLegend.innerHTML = trsLegend;

            window.requestAnimationFrame(() => this.resizeLegend);
        } else {
            this._footer.style.display = "none";
        }
    }
    resizeLegend() {
        const tHeight =
            this._legendHeight != null
                ? this._legendHeight
                : this.clientHeight / 2;
        if (tHeight > this._tableLegend.clientHeight) {
            this._table.parentNode.style.height =
                this.clientHeight - 22 - this._tableLegend.clientHeight + "px";
        } else if (tHeight < 20) {
            this._footer.style.height = 20;
            this._table.parentNode.style.height = this.clientHeight - 2 + "px";
        } else {
            this._footer.style.height = tHeight;
            this._table.parentNode.style.height =
                this.clientHeight - 22 - tHeight + "px";
        }
    }

    _marker() {
        return `<svg height="${this._rowstyle.fontsize}px" width="${this._rowstyle.fontsize}px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M8 4 V28 L26 16 z"></path></svg>`;
    }
    _setThFilterStyle(th, btn, clear) {
        if (clear) {
            btn.classList.remove("active");
            th.style.color = "";
            th.style.backgroundColor = "";
        } else {
            btn.classList.add("active");
            th.style.color = this.headerrowstyle.textcolorfilter;
            th.style.backgroundColor =
                this.headerrowstyle.backgroundcolorfilter;
        }
        this.saveItemState({ customFilters: this._customFilt });
    }
    _setFilter(th, target, clearFilt, dispName, text, entry) {
        if ($pm.hasPermissions) {
            const options = {
                cancel: () => {
                    this._customFilt = this._oldCustomFilt;
                },
                customText: `${this.elname}  ${!clearFilt
                    ? `${i18next.t('jornal_columnFilterEnabled')} ${dispName} : ${text}`
                    : `${i18next.t('jornal_columnFilterDisabled')} ${dispName}`
                    }`,
            };

            $pm.allowOperation(
                this,
                entry,
                "JournalUseFilters",
                () => {
                    this._setThFilterStyle(th, target, clearFilt);
                    this._reMonitoredEvents();
                },
                options
            );
        } else {
            this._setThFilterStyle(th, target, clearFilt);
            this._reMonitoredEvents();
        }
    }
    _onHeaderClick(e) {
        if (
            e.target.tagName === "SPAN" &&
            e.target.classList.contains("hmi-j-filter")
        ) {
            const th = e.target.parentNode.parentNode;
            const id = th.id;
            const dispName =
                this._tablecolumns[
                    this._tablecolumns.findIndex(el => el.baseIndex === this._baseFildsDict[id])
                ].displayname;
            const entry = $pm.hasPermissions && $pm.getEntryFromElement(this, "JournalUseFilters");
            if ($pm.hasPermissions && !$pm.checkAllow(entry)) {
                $pm.forbidOperation(this, entry.permType, `${this.elname} ${i18next.t('jornal_columnFilterDisabled')} ${dispName}`);
                return;
            }
            const target = e.target;
            let val = this._customFilt[id] ? this._customFilt[id].value : "";
            const type = target.dataset.type;
            const inputNum = new Inputs(this._main);
            let clearFilt = false;
            if (this._customFilt) {
                this._oldCustomFilt = JSON.parse(JSON.stringify(this._customFilt));
            }

            switch (type) {
                case "STRING":
                    inputNum.inputBoxText(e, `${i18next.t('jornal_filterTitle')}`, val, res => {
                        if (res == null) return;
                        if (res == "") {
                            clearFilt = true;
                            delete this._customFilt[id];
                        } else {
                            this._customFilt[id] = {
                                type: type,
                                value: res,
                            };
                        }
                        this._setFilter(
                            th,
                            target,
                            clearFilt,
                            dispName,
                            `${i18next.t('jornal_contains')} "${res}"`,
                            entry
                        );
                    });
                    break;
                case "BOOL":
                    const opt = [
                        { value: "true", name: `${i18next.t('true')}` },
                        { value: "false", name: `${i18next.t('false')}` },
                        { value: "all", name: `${i18next.t('all')}` },
                    ];
                    inputNum.inputBoxSelect(e, `${i18next.t('jornal_filterTitle')}`, opt, val, res => {
                        if (res == null) return;
                        if (res == "" || res == "all") {
                            clearFilt = true;
                            delete this._customFilt[id];
                        } else {
                            this._customFilt[id] = {
                                type: type,
                                value: res,
                            };
                        }
                        this._setFilter(
                            th,
                            target,
                            clearFilt,
                            dispName,
                            `${i18next.t('jornal_equal')} "${res}"`,
                            entry
                        );
                    });
                    break;
                case "DATE_AND_TIME":
                case "DATE":
                case "TOD":
                case "TIME":
                case "DT":
                    inputNum.inputBoxDataRange(e, `${i18next.t('jornal_filterTitle')}`, val, null, res => {
                        if (res == null) return;
                        let text = [];
                        if (
                            typeof res.min !== "number" &&
                            typeof res.max !== "number"
                        ) {
                            clearFilt = true;
                            delete this._customFilt[id];
                        } else {
                            this._customFilt[id] = {
                                type: "DATE_AND_TIME",
                                value: res,
                            };
                            res.min !== undefined &&
                                text.push(
                                    `>= ${_df.dateFormat(
                                        res.min,
                                        "dd.MM.yyyy HH:mm:ss"
                                    )}`
                                );
                            res.max !== undefined &&
                                text.push(
                                    `<= ${_df.dateFormat(
                                        res.max,
                                        "dd.MM.yyyy HH:mm:ss"
                                    )}`
                                );
                        }
                        this._setFilter(
                            th,
                            target,
                            clearFilt,
                            dispName,
                            text.join(", "),
                            entry
                        );
                    });
                    break;
                case "BYTE":
                case "INT":
                case "DINT":
                case "LREAL":
                case "DWORD":
                case "LWORD":
                case "WORD":
                case "REAL":
                case "LINT":
                case "SINT":
                case "UDINT":
                case "UINT":
                case "ULINT":
                case "USINT":
                    const option = {
                        min: _enums.Types[type].description.min,
                        max: _enums.Types[type].description.max,
                    };
                    inputNum.inputBoxNumberRange(
                        e,
                        `${i18next.t('jornal_filterTitle')}`,
                        val,
                        res => {
                            if (res == null) return;
                            const text = [];
                            if (
                                typeof res.min !== "number" &&
                                typeof res.max !== "number"
                            ) {
                                clearFilt = true;
                                delete this._customFilt[id];
                            } else {
                                this._customFilt[id] = {
                                    type: "NUMBER",
                                    value: res,
                                };
                                res.min !== undefined &&
                                    text.push(`>= ${res.min}`);
                                res.max !== undefined &&
                                    text.push(`<= ${res.max}`);
                            }
                            this.updateSeverityState();
                            this._setFilter(
                                th,
                                target,
                                clearFilt,
                                dispName,
                                text.join(", "),
                                entry
                            );
                        },
                        option
                    );
                    break;
                case "ENUM":
                    const en =
                        DataTypes.dataTypes[target.dataset.enum].DisplayValues;
                    inputNum.inputBoxEnum(e, `${i18next.t('jornal_filterTitle')}`, en, val, null, res => {
                        let setFilt = false;
                        let stack;
                        const text = [];
                        for (const item of res) {
                            if (typeof stack === "boolean") {
                                if (item !== stack) {
                                    setFilt = true;
                                    break;
                                }
                            } else {
                                stack = item;
                            }
                        }
                        if (!setFilt) {
                            clearFilt = true;
                            delete this._customFilt[id];
                        } else {
                            for (let i = 0; i < res.length; i++) {
                                if (res[i]) text.push(en[i]);
                            }
                            this._customFilt[id] = {
                                type: "ENUM",
                                value: res,
                            };
                        }
                        this._setFilter(
                            th,
                            target,
                            clearFilt,
                            dispName,
                            `${i18next.t('jornal_equally')} ${text.join(", ")}`,
                            entry
                        );
                    });
                    break;
                default:
                    console.log(type);
                    break;
            }
        } else if (!this._usearchive) {
            const { id, firstChild } = e.target;
            if (id !== "" && firstChild !== null) {
                this.sortColumn({ id, firstChild });
            }
        }
    }

    sortColumn({ id, firstChild }) {
        if (this._cacheSort) {
            this.updateSorting(firstChild, id, !this._cacheSort.forward);
        } else {
            this._cacheSort = {
                index: this._baseFildsDict[id],
                forward: true,
                id,
                el: this.createSortIcon(firstChild),
            };
        }
        this.saveItemState({
            sortOrder: this.sortOrder,
        });
        this.update();
    }

    updateSorting(colHeader, id, isForward) {
        const sortIcon = this._cacheSort.el;
        const index = this._baseFildsDict[id];
        const isTheSameColumn = this._cacheSort.index === index;
        if (isTheSameColumn) {
            this._cacheSort.forward = isForward;
            const ico = this._cacheSort.forward
                ? "hmi-j-step-up"
                : "hmi-j-step-down";
            sortIcon.className = `btn ${ico}`;
        } else {
            colHeader.insertBefore(sortIcon, colHeader.firstChild);
            this._cacheSort.forward = false;
            sortIcon.className = "btn hmi-j-step-down";
            this._cacheSort.index = index;
        }
        this._cacheSort.id = id;
    }

    createSortIcon(firstChild) {
        const el = document.createElement("div");
        el.className = "btn hmi-j-step-down";
        firstChild.insertBefore(el, firstChild.firstChild);
        return el;
    }

    setSeverity() {
        const dispName = `${i18next.t('jornal_priority_title')}`;
        const entry = $pm.hasPermissions && $pm.getEntryFromElement(this, "JournalUseFilters")
        if ($pm.hasPermissions && !$pm.checkAllow(entry)) {
            $pm.forbidOperation(this, entry.permType, `${this.elname} ${i18next.t('jornal_columnFilterDisabled')} ${dispName}`);
            return;
        }

        let val = this._customFilt["Severity"]
            ? this._customFilt["Severity"].value
            : "";
        let clearFilt = false;
        const inputNum = new Inputs(this._main);
        const type = "DINT";
        const th = this._main.querySelector("th#Severity");
        const target = this._main.querySelector("th#Severity span");
        const option = {
            min: _enums.Types[type].description.min,
            max: _enums.Types[type].description.max,
        };
        inputNum.inputBoxNumberRange(
            null,
            `${i18next.t('jornal_priority_filter')}`,
            val,
            res => {
                if (res == null) return;
                const text = [];
                if (
                    typeof res.min !== "number" &&
                    typeof res.max !== "number"
                ) {
                    clearFilt = true;
                    delete this._customFilt["Severity"];
                } else {
                    this._customFilt["Severity"] = {
                        type: "NUMBER",
                        value: res,
                    };
                    res.min !== undefined && text.push(`>= ${res.min}`);
                    res.max !== undefined && text.push(`<= ${res.max}`);
                }
                this.updateSeverityState();
                if (th && target) {
                    this._setFilter(
                        th,
                        target,
                        clearFilt,
                        dispName,
                        text.join(", "),
                        entry
                    );
                } else {
                    this._reMonitoredEvents();
                }
                this.saveItemState({ customFilters: this._customFilt });
            },
            option
        );
    }
    updateSeverityState() {
        const active = !this._customFilt["Severity"];
        this._toolBar.setToggleState(
            this._toolBar.elements["setSeverity"],
            !active
        );
    }

    _onDblClick(e) {
        if (e.target.tagName === "TD" && e.target.attributes.smark) {
            const i = this._recs.findIndex(el => {
                return el[3] == e.target.parentNode.id;
            });
            if (i > -1) {
                if (this._bookmarks[this._recs[i][3]]) {
                    delete this._bookmarks[this._recs[i][3]];
                    e.target.innerHTML = "";
                } else {
                    this._bookmarks[this._recs[i][3]] = this._recs[i];
                    e.target.innerHTML =
                        '<span align="center" style="pointer-events: none;font-size: medium;" class="btn hmi-j-f-marker"></span>';
                }
                this._saveMarks();
            }
        }
    }
    _saveMarks() {
        sessionStorage.setItem(
            `jr_${this.id}_bookmarks`,
            JSON.stringify(this._bookmarks)
        );
    }
    _loadMarks() {
        this._bookmarks =
            JSON.parse(sessionStorage.getItem(`jr_${this.id}_bookmarks`)) || {};
    }

    _selectNewRec(i, node) {
        if (!this.ischecked) {
            // если нету столбца с индикатором выбранной строки, то и добавлять маркер не нужно
            return;
        }

        if (this._select.rec) {
            if (this._select.rec[3] !== this._recs[i][3]) {
                this._select.td.innerHTML = "";
                node.firstChild.innerHTML = this._marker();
                this._select = { rec: this._recs[i], td: node.firstChild };
            }
        } else {
            node.firstChild.innerHTML = this._marker();
            this._select = { rec: this._recs[i], td: node.firstChild };
        }
    }

    _onBodyClick(e) {
        if (e.target.tagName == "BUTTON") {
            e.preventDefault();
            const entry = $pm.hasPermissions && $pm.getEntryFromElement(this, "JournalAck")
            if ($pm.hasPermissions && !$pm.checkAllow(entry)) {
                $pm.forbidOperation(this, entry.permType, this._genPermAckText(e.target.id));
                return;
            }
            this._ackSingle(e, entry);
        } else if (e.target.tagName === "TD") {
            const i = this._recs.findIndex(el => {
                return el[3] == e.target.parentNode.id;
            });

            if (i >= 0) this._selectNewRec(i, e.target.parentNode);

            // обработка события клик по ячейке
            let fildName = this._header.cells[e.target.cellIndex].id;
            if (fildName === "UpdateType") {
                // UpdateType - это число, а нужно выдавать текст, который хранится в EventChangeType
                fildName = "EventChangeType";
            }
            let r = {};
            for (
                let j = 0, length = this._header.cells.length;
                j < length;
                j++
            ) {
                const headerFild = this._header.cells[j];
                if (headerFild.id) {
                    const valueFild =
                        this._recs[i][this._baseFildsDict[headerFild.id]];
                    if (headerFild.id === "UpdateType") {
                        r["EventChangeType"] = this.enums(
                            "HMI.EventChangeType"
                        )[valueFild];
                        continue;
                    }
                    r[headerFild.id] =
                        valueFild === null || valueFild === undefined
                            ? ""
                            : valueFild; // возможно стоит отсавить null
                }
            }

            let event = new CustomEvent("cellclick", {
                detail: {
                    fild: fildName,
                    row: i,
                    rowvalue: r,
                    cellvalue: e.target.textContent,
                    el: e.target,
                    pageX: e.pageX,
                    pageY: e.pageY,
                },
            });
            this.dispatchEvent(event);
            event = null;
            r = null;
            this.updateLegend();
        }
    }

    _genPermAckText(id) {
        const recIndex = this._recs.findIndex(v => v[3] === id);
        if (recIndex < 0) return "";
        const messageIndex = this._baseFildsDict["Message"];
        const dt = _df.dateFormat(
            this._recs[recIndex][4],
            "dd.MM.yyyy HH:mm:ss"
        );
        const text = `${this.elname} ${i18next.t('jornal_acknowledged')} : ${dt}${messageIndex === undefined
            ? ""
            : " " + this._recs[recIndex][messageIndex]
            }`;
        return text;
    }

    _ackSingle(e, entry) {
        // нажата кнопка квит
        const btn = e.target;
        if (this._askackcomment) {
            const inputNum = new Inputs(this._main);
            inputNum.inputBoxText(e, `${i18next.t('jornal_enterComment')}`, "", comment => {
                if ($pm.hasPermissions) {
                    const customText = this._genPermAckText(btn.id);
                    if (customText)
                        $pm.allowOperation(
                            this,
                            entry,
                            "JournalAck",
                            this._ackApply.bind(this, [btn.id], comment),
                            {
                                customText
                            }
                        );
                } else {
                    this._ackApply([btn.id], comment);
                }
            });
        } else {
            if ($pm.hasPermissions) {
                const customText = this._genPermAckText(btn.id);
                if (customText)
                    $pm.allowOperation(
                        this,
                        entry,
                        "JournalAck",
                        this._ackApply.bind(this, [btn.id], ""),
                        {
                            customText
                        }
                    );
            } else {
                this._ackApply([btn.id], "");
            }
        }
    }

    _onBookMarksClick(e) {
        if (e.target.tagName == "BUTTON") {
            // удаление марки
            const el = this._body.querySelector(
                `[id="${e.target.parentNode.id}"]`
            );
            el.children[1].innerHTML = "";
            delete this._bookmarks[e.target.parentNode.id];
            e.target.parentNode.remove();
            this._saveMarks();
        } else if (e.target.attributes.bookmark) {
            // переход на марку
            this.getFromDate(null, this._bookmarks[e.target.id]);
        }
    }

    _onMarksClick(e) {
        e.preventDefault();
        if (!this._bookmarksDiv) {
            this._bookmarksDiv = document.createElement("div");

            this._bookmarksDiv.style.boxShadow =
                "0px 3px 10px rgba(35, 39, 76, 0.5)";
            this._bookmarksDiv.style.backgroundColor = this.tryToGetUserColor(this._filtersbackgroundcolor);
            this._bookmarksDiv.style.position = "absolute";
            this._bookmarksDiv.style.zIndex = "2";
            this._bookmarksDiv.style.pointerEvents = "all";

            this._header.querySelector("#mark").appendChild(this._bookmarksDiv);

            this._bookmarksDiv.onclick = this._onBookMarksClick.bind(this);
        }

        let lis = "";

        for (const key in this._bookmarks) {
            if (this._bookmarks.hasOwnProperty(key)) {
                const element = this._bookmarks[key];
                const time = _df.dateFormat(element[4]);
                lis += `
                <li bookmark class='bookmarksList' id="${key}">
                    <div style="flex:1; margin-right: 6px;">${time} ${this.enums("HMI.EventChangeType")[element[5]]
                    }</div><button class="ack">${i18next.t('delete')}</button>
                </li>
                `;
            }
        }
        this._bookmarksDiv.style.overflow = "auto";
        this._bookmarksDiv.style.maxHeight =
            this._table.parentElement.clientHeight -
            this._header.clientHeight -
            10;
        this._table.parentElement.clientHeight;

        if (!lis) {
            lis = `${i18next.t('jornal_addEventFavoriteTooltip')}`;
        }
        this._bookmarksDiv.innerHTML = `<ul>${lis}</ul>`;

        if (this._bookmarksDiv.style.display == "block") {
            this._bookmarksDiv.style.display = "none";
        } else {
            this._bookmarksDiv.style.display = "block";
        }
    }

    _generateFilterList() {
        let lis = "";
        for (let i = 0; i < this._filters.length; i++) {
            const element = this._filters[i];
            if(element.displayname === 'Активные сообщения') element.displayname = i18next.t("journal_active_messages")
            lis += `
                <li style="display: flex; align-items: center;">
                    <input
                        type="checkbox"
                        data-index=${i}
                        id="f_${i}"
                        name="apply"
                        value="${this._toBool(element.enabled)}"
                        ${this._toBool(element.enabled) ? "checked" : ""}
                        ${element.candisable === false ? "disabled" : ""}
                    >
                    <label
                        style="flex: 1; padding-left: 4px; padding-top: 2px;"
                        ${element.candisable === false ? "disabled" : ""}
                        for="f_${i}"
                    >${element.displayname}</label>
                </li>
            `;
        }
        return lis;
    }

    OpenObjectTree(e) {
        if (!this._ObjectTree) {
            this._ObjectTree = new ObjectTree(this._sources, true);
        }
        this._ObjectTree.onUpdate = newSources => {
            this._sources = newSources;
            this._reMonitoredEvents();
        };

        if (!this._isglobal) {
            const { itemId } = this._getItemId();
            this._ObjectTree.rootitem = itemId;
        }

        this._ObjectTree.selected = this._sources;
        this._ObjectTree.Open('', this.expandedlevel, null, null, true);
    }

    _onFilterClick(e, isVisible) {
        e?.preventDefault();
        if (!this._filterDiv) {
            const filterList = this._generateFilterList();
            if (filterList) {
                this._filterDiv = this.createFilterEl(filterList);
                this._main.appendChild(this._filterDiv);
            }
        }
        this._filterDivSet();

        if (typeof isVisible === "boolean") {
            this._filterDiv?.classList.toggle("hidden", !isVisible);
        } else {
            this._filterDiv?.classList.toggle("hidden");
        }
    }

    createFilterEl(lis) {
        const el = document.createElement("div");
        el.style.boxShadow = "0px 3px 10px rgba(35, 39, 76, 0.5)";
        el.style.position = "absolute";
        el.style.zIndex = "2";
        el.innerHTML = `<ul>${lis}</ul>`;
        // todo: сейчас this._onFilterSelectClick по вызывается дважды, нужно это исправить
        const inp = el.querySelector("ul");
        inp.onclick = this._onFilterSelectClick.bind(this);
        return el;
    }

    _filterDivSet() {
        if (this._filterDiv) {
            window.requestAnimationFrame(() => {
                if (!this._filterDiv) return;
                this._filterDiv.style.backgroundColor =
                    this._filtersbackgroundcolor;

                const w = this._filterDiv.offsetWidth;
                const btn = this._toolBar.elements["_onFilterClick"];
                if (btn.offsetLeft + w > Number(this.width)) {
                    this._filterDiv.style.left = `${Number(this.width) - w - 10
                        }px`;
                } else {
                    this._filterDiv.style.left = `${btn.offsetLeft}px`;
                }

                this._filterDiv.style.top = `${btn.offsetTop + btn.offsetHeight
                    }px`;

                const height =
                    this.clientHeight - (btn.offsetTop + btn.offsetHeight);
                this._filterDiv.firstChild.style.maxHeight = `calc( ${height}px - 2em )`;
            });
        }
    }

    _onFilterSelectClick(e) {
        e.stopPropagation();
        const el = e.target;
        if (el.dataset.index === undefined) return;
        if ($pm.hasPermissions) {
            const options = {
                cancel: () => {
                    el.checked = !el.checked;
                },
                customText: `${this.elname} ${el.checked ? `${i18next.t('jornal_filterEnabled')}` : `${i18next.t('jornal_filterDisabled')}`
                    } "${this._filters[el.dataset.index].displayname}"`,
            };
            $pm.resolveControl(
                this,
                "JournalUseFilters",
                this.applyFilter.bind(this, el),
                options
            );
        } else {
            this.applyFilter(el);
        }
    }
    applyFilter(el) {
        if (this._filters[el.dataset.index]) {
            this._filters[el.dataset.index].enabled = el.checked;
        }
        this.saveItemState({ filters: this._filters });
        this._reMonitoredEvents();
    }

    _reMonitoredEvents() {
        if (
            this._busyMonitoredEvents ||
            typeof this.monitoredItemId === "undefined"
        ) {
            this.needReCreate = true;
            return;
        }
        this._busyMonitoredEvents = true;
        this.sw
            .DeleteMonitoredEvents(this.monitoredItemId)
            .then(data => {
                if (data.code != 0) {
                    this._busyMonitoredEvents = false;
                    console.log(data.code.toString(16));
                    return;
                }
                this._createMonitoredEvents();
            })
            .catch(error => {
                console.log("error", error);
            });
        delete this.monitoredItemId;
    }

    AcknowledgeAll(e) {
        this.AcknowledgeMessages(e, true);
    }

    AcknowledgePage(e) {
        this.AcknowledgeMessages(e, false);
    }

    AcknowledgeMessages(e, all) {
        const ackMessages = this.getAckMessages(all);
        const customText = `${i18next.t('jornal_acknowledged')} ${ackMessages.length} ${i18next.t('jornal_acknowledgedMessages')}`
        const entry = $pm.hasPermissions && $pm.getEntryFromElement(this, "JournalGroupAck")
        if ($pm.hasPermissions && !$pm.checkAllow(entry)) {
            $pm.forbidOperation(this, entry.permType, customText);
            return;
        }

        if (ackMessages.length > 0) {
            const ids = ackMessages.map(({ rec }) => rec[3])
            if (this._askackcomment) {
                const inputNum = new Inputs(this._main);
                inputNum.inputBoxText(e, `${i18next.t('jornal_enterComment')}`, "", comment => {
                    if ($pm.hasPermissions) {
                        $pm.allowOperation(
                            this,
                            entry,
                            "JournalGroupAck",
                            this._ackApply.bind(this, ids, comment, ackMessages),
                            { customText }
                        );
                    } else {
                        this._ackApply(ids, comment, ackMessages);
                    }
                });
            } else {
                if ($pm.hasPermissions) {
                    $pm.allowOperation(
                        this,
                        entry,
                        "JournalGroupAck",
                        this._ackApply.bind(this, ids, "", ackMessages),
                        { customText }
                    );
                } else {
                    this._ackApply(ids, "", ackMessages);
                }
            }
        }
    }

    getAckMessages(all) {
        const ackMessages = [];

        for (let index = 0; index < this._body.childNodes.length; index++) {
            const element = this._body.childNodes[index];
            if (
                all ||
                (this._scrollTop <= element.offsetTop &&
                    this._table.parentNode.clientHeight + this._scrollTop >
                    element.offsetTop + element.clientHeight)
            ) {
                const i = this._recs.findIndex(item => item[3] === element.id);
                if (i >= 0 && !this._recs[i][1]) {
                    ackMessages.push({
                        rec: this._recs[i],
                        btnAck: element.querySelector("button.ack")
                    });
                }
            } else if (
                this._table.parentNode.clientHeight + this._scrollTop <
                element.offsetTop
            ) {
                break;
            }
        }

        return ackMessages;
    }

    _ackApply(ids, comment, ackMessages) {
        if (comment == null) return;

        ackMessages?.forEach(({ btnAck }) => {
            if (btnAck) {
                btnAck.disabled = true;
            }
        });

        this.sw
            .AcknowledgeEvents(ids, comment)
            .then(({ code }) => {
                if (code != 0) {
                    console.log(code.toString(16));
                    return;
                }
                this.update();
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    _onLegendClick(e) {
        if (e) e.preventDefault();
        this.SetParameter("showlegend", !this.showlegend, true);
        this.update();
    }

    _onOneForwardClick() {
        if (!this._usearchive) return;
        if (this._recs.length === 0 || !this._getArchived) return;
        const cp = {
            time: this._recs[this._recs.length - 1][6],
            eventId: this._recs[this._recs.length - 1][3],
            alarmId: this._recs[this._recs.length - 1][7],
        };
        const l = parseInt((this.limit / 100) * 10);

        let start = 0,
            end = 0;
        if (this._usetimefilter) {
            start = this._till - this._interval;
            end = this._till;
        }

        let packet = {
            inverse: true,
            endTime: end,
            fields: this._baseFilds,
            filter: this._calcFilters(),
            maxRecs: l,
            maxSize: 0,
            path: "",
            startTime: start,
            taskId: 0,
            continuationPoint: cp,
        };
        if (typeof this._archiveref != "undefined")
            packet.archiveId = this._archiveref;

        packet = Object.assign(packet, this._getItemId());

        this.sw
            .getArchivedEvents(packet)
            .then(data => {
                if (data.code != 0) {
                    console.log(data.code.toString(16));
                    this._loadDown = false;
                    return;
                }
                if (data.recs) {
                    const ind = data.recs.findIndex(el => el[3] === cp.eventId);
                    if (ind > -1) data.recs.splice(ind, 1);
                    if (data.recs.length > 0) {
                        const offset =
                            this._body.firstChild.offsetHeight *
                            data.recs.length;
                        // this._table.style.overflow = 'hidden';
                        this._recs.splice(0, data.recs.length);
                        this._recs = this._recs.concat(data.recs);
                        this.update();
                        //    this._table.style.overflow = 'auto';

                        setTimeout(
                            () =>
                                (this._table.parentElement.scrollTop -= offset),
                            500
                        );

                        //this._table.parentElement.scrollTop -= offset;
                    }
                }
                this._loadDown = false;
            })
            .catch(error => {
                this._loadDown = false;
                console.log("error", error);
            });
    }

    async getFromDate(date, startRec) {
        const date_utc = date;
        if (this._usetimefilter) {
            const start = this._till - this._interval;
            const end = this._till;
            const odt = date;
            if (odt < start || odt > end) return;
        }

        this._loadDown = true;
        this._loadUp = true;
        let intDate;
        if (date) {
            intDate = typeof date_utc == "number" ? date_utc : date.getTime();
        }

        const l = parseInt(this.limit / 2);

        let start = 0,
            end = 0;
        if (this._usetimefilter) {
            start = this._till - this._interval;
            end = this._till;
        }

        let packet = {
            inverse: true,
            fields: this._baseFilds,
            filter: this._calcFilters(),
            maxRecs: l,
            maxSize: 0,
            path: "",
            startTime: start,
            taskId: 0,
        };
        if (typeof this._archiveref != "undefined")
            packet.archiveId = this._archiveref;

        packet = Object.assign(packet, this._getItemId());
        let cp;
        if (startRec) {
            cp = {
                time: startRec[6],
                eventId: startRec[3],
                alarmId: startRec[7],
            };
            packet["continuationPoint"] = cp;
        } else {
            packet["endTime"] = intDate;
        }

        await this.sw
            .getArchivedEvents(packet)
            .then(data => {
                if (data.code != 0) {
                    console.log(data.code.toString(16));
                    return;
                }
                if (cp) {
                    const ind = data.recs.findIndex(el => el[3] === cp.eventId);
                    if (ind > -1) data.recs.splice(ind, 1);
                }
                if (data.recs) {
                    this._recs = [];
                    if (data.recs.length > 0) {
                        this._table.parentElement.scrollTop = 0;
                        this._recs = data.recs;
                    }
                }
                packet.inverse = false;
                if (date_utc) {
                    packet.startTime = intDate;
                    packet.endTime = end;
                }
                return this.sw.getArchivedEvents(packet);
            })
            .then(data => {
                if (data.code != 0) {
                    console.log(data.code.toString(16));
                    return;
                }
                if (data.recs) {
                    let recs = data.recs.reverse();
                    if (startRec) {
                        recs = recs.concat([startRec]);
                    }
                    this._recs = recs.concat(this._recs);
                    this.update();
                    if (this._body.childNodes.length > 0) {
                        const position =
                            this._body.childNodes[0].offsetHeight *
                            recs.length -
                            this._table.parentElement.offsetHeight / 2;
                        this._table.parentElement.scrollTop = position;
                    } else {
                        this._table.parentElement.scrollTop = 0;
                    }
                }
            })
            .then(() => {
                this._loadDown = false;
                this._loadUp = false;
            })
            .catch(error => {
                this._loadDown = false;
                this._loadUp = false;
                console.log("error", error);
            });
    }

    _onOneBackClick() {
        if (!this._usearchive) return;
        if (this._recs.length == 0 || !this._getArchived) {
            return;
        }
        const cp = {
            time: this._recs[0][6],
            eventId: this._recs[0][3],
            alarmId: this._recs[0][7],
        };
        const l = parseInt((this.limit / 100) * 10);

        let start = 0,
            end = 0;
        if (this._usetimefilter) {
            start = this._till - this._interval;
            end = this._till;
        }

        let packet = {
            inverse: false,
            endTime: end,
            fields: this._baseFilds,
            filter: this._calcFilters(),
            maxRecs: l,
            maxSize: 0,
            path: "",
            startTime: start,
            taskId: 0,
            continuationPoint: cp,
        };
        if (typeof this._archiveref != "undefined")
            packet.archiveId = this._archiveref;

        packet = Object.assign(packet, this._getItemId());

        this.sw
            .getArchivedEvents(packet)
            .then(data => {
                if (data.code != 0) {
                    console.log(data.code.toString(16));
                    this._loadUp;
                    return;
                }
                if (data.recs) {
                    const ind = data.recs.findIndex(el => el[3] === cp.eventId);
                    if (ind > -1) data.recs.splice(ind, 1);
                    if (data.recs.length > 0) {
                        const offset =
                            this._body.firstChild.offsetHeight *
                            data.recs.length;
                        this._table.parentElement.scrollTop += offset;
                        this._recs.splice(this._recs.length - data.recs.length);
                        const recs = data.recs.reverse();
                        this._recs = recs.concat(this._recs);
                        this.update();
                    }
                }
                this._loadUp = false;
            })
            .catch(error => {
                this._loadUp = false;
                console.log("error", error);
            });
    }

    Download() {
        const fileName =
            generateFileName(
                this.exportnameformat,
                this.elname,
                this.parentElement.getAttribute("objectid")
            ) + ".csv";

        if ($pm.hasPermissions) {
            const options = window.savePath
                ? {
                    customText: `${this.elname} ${i18next.t('jornal_savingMessagesFile')} (${window.savePath}${fileName})${window.saveDeviceDesc}`,
                }
                : null;
            $pm.resolveControl(
                this,
                "JournalSave",
                this._Download.bind(this, fileName),
                options
            );
        } else {
            this._Download(fileName);
        }
    }

    _Download(fileName) {
        let header = "";

        for (let i = 0; i < this._tablecolumns.length; i++) {
            const element = this._tablecolumns[i];
            if (this._toBool(element.visibility)) {
                if (element.field != "Icon" && element.field != "Ack") {
                    header += `${element.displayname};`;
                }
            }
        }

        let row = (header += "\n");

        for (let index = 0; index < this._recs.length; index++) {
            const element = this._sortRecs[index];

            for (let i = 0; i < this._tablecolumns.length; i++) {
                const col = this._tablecolumns[i];
                if (!this._toBool(col.visibility)) {
                    continue;
                }
                switch (col.field) {
                    case "Ack":
                        break;
                    case "UpdateType":
                        row += `${this.enums(col.fieldtype)[element[col.baseIndex]]
                            };`;
                        break;
                    case "Icon":
                        break;
                    default:
                        if (typeof element[col.baseIndex] != "undefined") {
                            let isDT = false;
                            switch (col.fieldtype) {
                                case "DATE_AND_TIME":
                                    if (!col.valueformat)
                                        col.valueformat = "dd.MM.yyyy HH:mm:ss";
                                    isDT = true;
                                    break;
                                case "DATE":
                                    if (!col.valueformat)
                                        col.valueformat = "dd.MM.yyyy";
                                    isDT = true;
                                    break;
                                case "TIME":
                                    if (!col.valueformat)
                                        col.valueformat = "HH:mm:ss";
                                    isDT = true;
                                    break;
                            }
                            if (isDT) {
                                const val =
                                    element[col.baseIndex] !== 0
                                        ? _df.dateFormat(
                                            element[col.baseIndex],
                                            col.valueformat
                                        )
                                        : "";
                                row += `${val};`;
                            } else {
                                row += `${element[col.baseIndex] === null
                                    ? ""
                                    : element[col.baseIndex]
                                    };`;
                            }
                        } else {
                            row += `;`;
                        }
                }
            }
            row += "\n";
        }
        exportTextfile(row, fileName, true);
    }

    Print() {
        if ($pm.hasPermissions) {
            const options = window.clientPrinter
                ? {
                    customText: `${this.elname} ${i18next.t("journal_printMessages")} ${window.PrinterName}`,
                }
                : null;
            $pm.resolveControl(
                this,
                "JournalPrint",
                this._Print.bind(this),
                options
            );
        } else {
            this._Print();
        }
    }
    _Print() {
        const hiddenColumnsIds = ["check", "mark", "Acked"];
        const frameContent = this.createFrameContent(hiddenColumnsIds);

        if (window.ipc && window.clientPrinter) {
            window.ipc
                .get()
                .send(
                    "server",
                    "print",
                    `data:text/html;charset=utf8,${frameContent}`
                );
        } else {
            let iframe = document.createElement("iframe");
            iframe.srcdoc = frameContent;
            document.body.appendChild(iframe);

            const proportionsInPercent =
                this.calcProportionsInPercent(hiddenColumnsIds);

            iframe.onload = () => {
                this.updateColumnsWidth(
                    iframe,
                    proportionsInPercent,
                    hiddenColumnsIds
                );

                requestAnimationFrame(() => {
                    iframe.focus();
                    iframe.contentWindow.print();
                    iframe.remove();
                    iframe = null;
                });
            };
        }

        return true;
    }

    createFrameContent(hiddenColumnsIds) {
        const currentStyles = [
            ...this.shadowRoot.querySelectorAll("style"),
        ].reduce((acc, next) => acc + next.innerText, "");
        // Webpack добавляет артефакты в виде комментариев, из-за которых alt-linux не может распечатать журнал, нужно их удалить:
        const currentStylesWithoutComments = currentStyles.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, '');
        const allColumns = [
            ...this._table.querySelectorAll("table thead th"),
        ];
        const hiddenIndexes = hiddenColumnsIds
            .map(hiddenColId => allColumns.findIndex(col => col.id === hiddenColId))
            .filter(x => x > -1);
        const hideColumnsStyles = hiddenIndexes
            .map(i => ++i)
            .reduce(
                (acc, next) => `${acc} th:nth-child(${next}),td:nth-child(${next}){display: none;} `,
                ""
            );
        const allStyles = `
            <style>
                ${currentStylesWithoutComments.replace(new RegExp(":host", "g"), "")}
                th span { display:none; }
                ${hideColumnsStyles}
            </style>
        `;
        return allStyles + this._table.parentElement.innerHTML;
    }

    calcProportionsInPercent(hiddenColumnsIds) {
        const proportionsInPx = [
            ...this._table.querySelectorAll("table thead th"),
        ]
            .filter(x => hiddenColumnsIds.indexOf(x.id) === -1)
            .map(x => parseFloat(x.style.width));
        const sum = proportionsInPx.reduce((a, b) => a + b, 0);
        return proportionsInPx.map(x => `${(x * 100) / sum}px`);
    }

    updateColumnsWidth(iframe, proportionsInPercent, hiddenColumnsIds) {
        let printDocument = iframe.contentWindow || iframe.contentDocument;
        if (printDocument.document) {
            printDocument = printDocument.document;
        }

        printDocument.querySelector("table").style.width = "100%";

        [...printDocument.querySelectorAll("table thead th")]
            .filter(x => hiddenColumnsIds.indexOf(x.id) === -1)
            .forEach((x, i) => {
                x.style.width = proportionsInPercent[i];
            });
    }

    updateStatusBar() {
        if (this._rowstyle) {
            this._statusBar.style.fontFamily = '"' + this._rowstyle.FontName + '"';
            this._statusBar.style.fontSize = this._rowstyle.FontSize;
        }
        if (!this._autoscroll) {
            this._statusBar.style.display = this._showStatusBar
                ? "block"
                : "none";
            if (this.usetimefilter) {
                const start = this._till - this._interval;
                const end = this._till;
                if (this._statusBar.querySelector("ms-interval#inter") == null)
                    this._statusBar.innerHTML = `
                        <div style="height:18px; display: flex;justify-content: space-between;">
                            <ms-dtpicker utc="true" id="left" datetimetype="1" size="40" isreadonly="false" datetime="${start}" style="width: 180px; border: 1px solid;position: unset;"></ms-dtpicker>
                            <ms-interval utc="true" id="inter" isreadonly="false" allownull="true" backgroundcolor="" datetime="${this._interval}" style="width:110px;border:1px solid;position: unset;"></ms-interval>
                            <ms-dtpicker utc="true" id="right" datetimetype="1" size="40" isreadonly="false" datetime="${end}" style="width: 180px; border: 1px solid;position: unset;"></ms-dtpicker>
                        </div>
                    `;
                const inter =
                    this._statusBar.querySelector("ms-interval#inter");
                const right =
                    this._statusBar.querySelector("ms-dtpicker#right");
                const left = this._statusBar.querySelector("ms-dtpicker#left");
                right.force = true;
                left.force = true;
                inter.force = true;
                left.datetime = start;
                right.datetime = end;
                inter.datetime = this._interval;

                inter.prop_link["datetime"] = (a, b, val, attrName) => {
                    if (attrName === "datetime") {
                        this.SetParameter("interval", val);
                        left.datetime = this._till - val;
                    }
                };
                right.prop_link["datetime"] = (a, b, val, attrName) => {
                    if (attrName === "datetime") {
                        this.SetParameter("till", val);
                        left.datetime = this._till - val;
                    }
                };
                left.prop_link["datetime"] = (a, b, val, attrName) => {
                    if (attrName === "datetime") {
                        this.SetParameter("till", val + this._interval);
                        right.datetime = this._interval + val;
                    }
                };
            } else {
                if (this._usearchive && this._recs.length > 0) {
                    this._statusBar.style.backgroundColor =
                        this._legendbackgroundcolor;
                    const tStart = _df.dateFormat(this._recs[0][4]);
                    const tEnd = _df.dateFormat(
                        this._recs[this._recs.length - 1][4]
                    );
                    this._statusBar.innerText = `${i18next.t('jornal_timeFilter_skipped')}: ${this._skip} ${i18next.t('jornal_timeFilter_displayedInterval')}: ${tStart} - ${tEnd}`;
                } else {
                    const tEnd =
                        this._recs.length > 0
                            ? _df.dateFormat(
                                this._recs[this._recs.length - 1][4]
                            )
                            : "";
                    this._statusBar.innerText = `${i18next.t('jornal_timeFilter_numberMessages')}: ${this._recs.length}, ${i18next.t('jornal_timeFilter_time')}: ${tEnd}`;
                }
            }
        } else {
            if (this._usearchive) {
                this._skip = 0;
                this._statusBar.style.display = "none";
            } else {
                this._statusBar.style.display = this._showStatusBar
                    ? "block"
                    : "none";
                const tEnd =
                    this._recs.length > 0
                        ? _df.dateFormat(this._recs[this._recs.length - 1][4])
                        : "";
                this._statusBar.innerText = `${i18next.t('jornal_timeFilter_numberMessages')}: ${this._recs.length}, ${i18next.t('jornal_timeFilter_autoscrollTime')}: ${tEnd}`;
            }
        }
    }

    _onAutoPlayClick(e) {
        if (this._usetimefilter && !this._autoscroll) {
            return;
        }

        this._autoSetAutoscroll = false;
        this.SetParameter("autoscroll", !this._autoscroll, true);
        if (this._autoscroll) {
            this._autoscrollInit = true;
            this._table.parentElement.scrollTop = 0;
            if (!this._usearchive) {
                const activeTime = this._table.querySelector("#ActiveTime");
                if (activeTime) {
                    this.sortColumn(activeTime);
                }
            }
        }
        this._updatePlayBtn();

        if (typeof this._interval !== "undefined") {
            this.updateStatusBar();
        }
    }

    _updatePlayBtn() {
        this._toolBar.setToggleState(
            this._toolBar.elements["_onAutoPlayClick"],
            this._autoscroll
        );
        if (this._autoscroll) {
            if (this._usearchive) {
                this._getArchived(0, 0, true)
                    .then(() => {
                        window.requestAnimationFrame(() => {
                            this._autoscrollInit = false;
                        });
                    })
                    .catch(() => {
                        this._autoscrollInit = false;
                    })
            } else {
                window.requestAnimationFrame(() => {
                    this._autoscrollInit = false;
                });
            }
        } else {
            this.refreshArchivedRecs = false;
        }
    }

    _goFirstPage(e) {
        if (this._usearchive) {
            this.updateArchivedEvents(true);
        } else {
            if (this._table.parentElement.scrollTop) {
                this._table.parentElement.scrollTop = 0;
            }
        }
        this.updateStatusBar();
    }
    _goLastPage(e) {
        if (this._usearchive) {
            this.updateArchivedEvents(false);
        } else {
            const parentElement = this._table.parentElement;

            if (
                parentElement.scrollTop !==
                parentElement.scrollHeight - parentElement.clientHeight
            ) {
                parentElement.scrollTop =
                    parentElement.scrollHeight - parentElement.clientHeight;
            }
        }

        this.updateStatusBar();
    }

    _showTimeFiltr(e) {
        this.SetParameter("usetimefilter", !this.usetimefilter);
        this.updateStatusBar();
    }

    GoToDate(e) {
        const inputDate = new Inputs(this._main);
        inputDate.inputBoxData(e, `${i18next.t('jornal_goDate_title')}`, new Date(), val => {
            this.getFromDate(val);
        });
    }

    Update() {
        if (this._usearchive && !this.needReCreate) {
            this.updateArchivedEvents(true);
        }
    }

    Clear() {
        this._recs = [];
        this._table.parentElement.scrollTop = 0;
        this.update();
    }

    FirstPage() {
        this._goFirstPage();
    }
    PreviousPage() {
        const y =
            this._table.parentElement.scrollTop -
            this._table.parentNode.clientHeight;
        this._table.parentElement.scroll({
            top: y,
            left: this._table.parentElement.scrollLeft,
            behavior: "smooth",
        });
    }
    NextPage() {
        const y =
            this._table.parentElement.scrollTop +
            this._table.parentNode.clientHeight;
        this._table.parentElement.scroll({
            top: y,
            left: this._table.parentElement.scrollLeft,
            behavior: "smooth",
        });
    }
    LastPage() {
        this._goLastPage();
    }
    Acknowledge(e) {
        if ($pm.hasPermissions) {
            $pm.resolveControl(
                this,
                "JournalAck",
                this._Acknowledge.bind(this, e, true)
            );
        } else {
            this._Acknowledge(e, true);
        }
    }
    _Acknowledge(e, force) {
        if (this._select.td) {
            if (
                this._scrollTop <= this._select.td.offsetTop &&
                this._table.parentNode.clientHeight + this._scrollTop >
                this._select.td.offsetTop + this._select.td.clientHeight
            ) {
                const i = this._recs.findIndex(item => {
                    return item[3] === this._select.rec[3];
                });
                if (i >= 0 && !this._recs[i][1]) {
                    const comment = e.Kommentarij || "";
                    const ids = [this._recs[i][3]];
                    if (this._askackcomment && !force) {
                        const inputNum = new Inputs(this._main);
                        inputNum.inputBoxText(
                            e,
                            `Please enter comment for ${ids.length}(s)`,
                            "",
                            comment => {
                                this._ackApply(ids, comment);
                            }
                        );
                    } else {
                        this._ackApply(ids, comment);
                    }
                }
            }
        }
    }
    NextMessage() {
        if (this._select.td) {
            let i = this._sortRecs.findIndex(el => {
                return el[3] === this._select.rec[3];
            });
            if (i > 0) {
                i--;
                this._selectNewRec(i, this._body.childNodes[i]);
                //this._select.rec = this._sortRecs[i];
                const offset =
                    this._body.childNodes[i].offsetTop -
                    this._body.childNodes[i].offsetHeight;
                if (
                    offset < this._scrollTop ||
                    offset >
                    this._scrollTop + this._table.parentNode.clientHeight
                ) {
                    this._table.parentElement.scroll({
                        top:
                            this._body.childNodes[i].offsetTop -
                            this._body.childNodes[i].offsetHeight,
                        left: this._table.parentElement.scrollLeft,
                        behavior: "smooth",
                    });
                }
                this.update();
            }
        }
    }
    PreviousMessage() {
        if (this._select.td) {
            let i = this._sortRecs.findIndex(el => {
                return el[3] === this._select.rec[3];
            });
            if (i < this._sortRecs.length - 1) {
                i++;
                this._selectNewRec(i, this._body.childNodes[i]);
                //this._select.rec = this._sortRecs[i];
                const offset =
                    this._body.childNodes[i].offsetTop -
                    this._body.childNodes[i].offsetHeight;
                if (
                    offset < this._scrollTop ||
                    offset + this._body.childNodes[i].offsetHeight * 2 >
                    this._scrollTop + this._table.parentNode.clientHeight
                ) {
                    this._table.parentElement.scroll({
                        top:
                            this._body.childNodes[i].offsetTop +
                            this._body.childNodes[i].offsetHeight * 2 -
                            this._table.parentElement.offsetHeight,
                        left: this._table.parentElement.scrollLeft,
                        behavior: "smooth",
                    });
                }
                this.update();
            }
        }
    }
    ClearOptions() {
        this.saveItemState({ customFilters: undefined });
        this.saveItemState({ sortOrder: undefined });
        this.saveItemState({ filters: undefined });
        this._customFilt = {};
        const th = this._header.querySelectorAll(".active");
        for (let i = 0; i < th.length; i++) {
            const el = th[i];
            el.classList.remove("active");
            el.parentNode.parentNode.style.color = "";
            el.parentNode.parentNode.style.backgroundColor = "";
        }
        try {
            this._filters = JSON.parse(this.getAttribute("filters")).filter;
            if (
                typeof this._filters === "object" &&
                !Array.isArray(this._filters)
            )
                this._filters = [this._filters];
            if (this._filterDiv) {
                this._filterDiv.firstChild.innerHTML =
                    this._generateFilterList();
            }
            this.updateSeverityState();
        } catch (error) { }
        this._reMonitoredEvents();
    }

    attributeChangedCallback(attrName, oldVal, newVal, itemIndex) {
        if (this.constructor.observedAttributes.indexOf(attrName) < 0) {
            const p = attrName.split(".");
            if (p.length > 1) {
                if (this[p[0]][p[1]][p[2].toLowerCase()] != newVal) {
                    this[p[0]][p[1]][p[2].toLowerCase()] = newVal;
                    if (p[0] === "filters") {
                        if (this._filterDiv) {
                            this._filterDiv.firstChild.innerHTML =
                                this._generateFilterList();
                        }
                        this._reMonitoredEvents();
                    }
                    if (this.prop_link[p[0]]) {
                        this.prop_link[p[0]](
                            this.pId ? this.pId + "/" + this.id : this.id,
                            this.Links[p[0]],
                            this._paneldatasource_data || attrName,
                            p[0],
                            itemIndex
                        );
                    }
                }
            }
        } else {
            super.attributeChangedCallback(attrName, oldVal, newVal);
        }
    }

    ShowLegend() {
        this._onLegendClick();
    }

    disableElement() {
        if (this._maskElement) return;

        const zIndex = parseInt(this.z || 1, 10);
        const maskElement = this.createMaskElement(zIndex);

        this.shadowRoot.appendChild(maskElement);
        this._maskElement = maskElement;
    }
}